webpackJsonp([1],Array(56).concat([
/* 56 */
/***/ (function(module, exports) {

module.exports = {"environment_name":"production","api_base_url":"https://api.kungfood.co.uk/api/fe/","base_url":"https://api.kungfood.co.uk","sentry":"https://444a1b1ddbd34fc28e0ca1c05983e73c@sentry.io/1326248","stripe_token_location_1":"pk_live_6ZeQkjGQb39b6yiIKIKzYhM8","stripe_token_location_2":"pk_live_9dL7AVTlLgp0tUDBii8VAWxt","wallet_enabled":true}

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(489)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  "data-v-147f2c35",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/food.9b9e9ef.png";

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lamps-right.248da93.png";

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _localStorage = __webpack_require__(71);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isLoggedIn() {
  var user = _localStorage2.default.get('user');
  if (user) {
    var token = user.token;
    return token;
  }
  return null;
}

function hasUserInfo() {
  var user = _localStorage2.default.get('user');
  if (user) {
    return user;
  }
  return null;
}

function hasActiveLocation() {
  var location = _localStorage2.default.get('location');
  if (location) {
    var curDate = new Date();
    var setLocationDate = new Date(location.setDate);
    var timeDiff = Math.abs(setLocationDate.getTime() - curDate.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays >= 7) {
      return null;
    }

    return location;
  }

  return null;
}

function hasCart() {
  var cart = _localStorage2.default.get('cart');

  if (cart) {
    var curDate = new Date();
    var setDate = new Date(cart.setDate);
    var timeDiff = Math.abs(setDate.getTime() - curDate.getTime());
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays >= 7) {
      return [];
    }

    return cart;
  }

  return [];
}

exports.default = {
  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['getOrderType'])),
  token: isLoggedIn(),
  user: hasUserInfo(),
  location: hasActiveLocation(),
  topError: null,
  isLoading: false,
  deliveryCost: 0,
  adminFee: 0,
  discountThreshold: 0,
  minimumForDelivery: 0,
  websiteAvailability: {
    isOpen: true,
    nextOpeningHour: null,
    nextOpeningDay: null,
    canTakeOrders: true,
    canDoDelivery: false
  },
  websiteContacts: {
    email: null,
    phone: null,
    address: null
  },
  socials: {
    facebook: null,
    instagram: null,
    twitter: null,
    youtube: null
  },
  cart: hasCart(),
  discount: {
    code: null,
    amount: null,
    type: null
  }
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AUTH = exports.AUTH = 'AUTH';
var SIGNOUT = exports.SIGNOUT = 'SIGNOUT';

var GENERAL_SETTINGS = exports.GENERAL_SETTINGS = 'GENERAL_SETTINGS';

var STATUS = exports.STATUS = 'STATUS';
var UPDATE_CART = exports.UPDATE_CART = 'UPDATE_CART';
var ORDER_TYPE = exports.ORDER_TYPE = 'ORDER_TYPE';
var DISCOUNT = exports.DISCOUNT = 'DISCOUNT';

var LOCATION = exports.LOCATION = 'LOCATION';

var LOADING_ON = exports.LOADING_ON = 'LOADING_ON';
var LOADING_OFF = exports.LOADING_OFF = 'LOADING_OFF';

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/KF-logo-white.1e276b2.png";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/visa.542a55b.png";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lamps-left.6ec91ed.png";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(557),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(491)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Notifications = __webpack_require__(526);

var _Notifications2 = _interopRequireDefault(_Notifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationStore = {
  state: [], removeNotification: function removeNotification(index) {
    this.state.splice(index, 1);
  },
  notify: function notify(notification) {
    this.state.push(notification);
  }
};

var NotificationsPlugin = {
  install: function install(Vue) {
    Object.defineProperty(Vue.prototype, '$notifications', {
      get: function get() {
        return NotificationStore;
      }
    });
    Vue.component('Notifications', _Notifications2.default);
  }
};

exports.default = NotificationsPlugin;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formGroupInput = __webpack_require__(525);

var _formGroupInput2 = _interopRequireDefault(_formGroupInput);

var _Dropdown = __webpack_require__(524);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalComponents = {
  install: function install(Vue) {
    Vue.component('fg-input', _formGroupInput2.default);
    Vue.component('drop-down', _Dropdown2.default);
  }
};

exports.default = GlobalComponents;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Layout = __webpack_require__(521);

var _Layout2 = _interopRequireDefault(_Layout);

var _NotFoundPage = __webpack_require__(522);

var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);

var _homepage = __webpack_require__(531);

var _homepage2 = _interopRequireDefault(_homepage);

var _selectLocationPopup = __webpack_require__(532);

var _selectLocationPopup2 = _interopRequireDefault(_selectLocationPopup);

var _menu = __webpack_require__(534);

var _menu2 = _interopRequireDefault(_menu);

var _lunchBoxes = __webpack_require__(533);

var _lunchBoxes2 = _interopRequireDefault(_lunchBoxes);

var _contact = __webpack_require__(530);

var _contact2 = _interopRequireDefault(_contact);

var _checkout = __webpack_require__(528);

var _checkout2 = _interopRequireDefault(_checkout);

var _response = __webpack_require__(529);

var _response2 = _interopRequireDefault(_response);

var _profile = __webpack_require__(538);

var _profile2 = _interopRequireDefault(_profile);

var _restorePassword = __webpack_require__(539);

var _restorePassword2 = _interopRequireDefault(_restorePassword);

var _setPassword = __webpack_require__(540);

var _setPassword2 = _interopRequireDefault(_setPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultMetaTags = [{
  name: 'description',
  content: 'The Local Chinese Takeaway in the City of London, Clerkenwell and Liverpool Street.'
}, {
  property: 'og:type',
  content: 'website'
}, {
  property: 'og:description',
  content: 'The Local Chinese Takeaway in the City of London, Clerkenwell and Liverpool Street.'
}, {
  property: 'og:image',
  content: 'https://api.kungfood.co.uk/img/kungfood.png'
}, {
  property: 'twitter:card',
  content: 'summary'
}, {
  property: 'twitter:description',
  content: 'The Local Chinese Takeaway in the City of London, Clerkenwell and Liverpool Street.'
}, {
  property: 'twitter:image',
  content: 'https://api.kungfood.co.uk/img/kungfood.png'
}];

var routes = [{
  path: '/',
  component: _Layout2.default,
  children: [{
    path: '',
    name: 'homepage',
    component: _homepage2.default,
    meta: {
      title: 'Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags.concat({
        property: 'og:title',
        content: 'Kung Food Chinese Takeaway'
      }, {
        property: 'og:url',
        content: 'https://kungfood.co.uk/'
      }, {
        property: 'twitter:title',
        content: 'Kung Food Chinese Takeaway'
      }, {
        property: 'twitter:url',
        content: 'https://kungfood.co.uk/'
      })
    },
    children: [{
      path: 'select-location',
      name: 'select-location',
      component: _selectLocationPopup2.default,
      meta: {
        title: 'Select Location - Kung Food Chinese Takeaway',
        metaTags: defaultMetaTags.concat({
          property: 'og:title',
          content: 'Select Location - Kung Food Chinese Takeaway'
        }, {
          property: 'og:url',
          content: 'https://kungfood.co.uk/select-location'
        }, {
          property: 'twitter:title',
          content: 'Select Location - Kung Food Chinese Takeaway'
        }, {
          property: 'twitter:url',
          content: 'https://kungfood.co.uk/select-location'
        })
      }
    }]
  }, {
    path: 'profile',
    name: 'profile',
    component: _profile2.default,
    meta: {
      title: 'Profile - Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags.concat({
        property: 'og:title',
        content: 'Profile - Kung Food Chinese Takeaway'
      }, {
        property: 'og:url',
        content: 'https://kungfood.co.uk/profile'
      }, {
        property: 'twitter:title',
        content: 'Profile - Kung Food Chinese Takeaway'
      }, {
        property: 'twitter:url',
        content: 'https://kungfood.co.uk/profile'
      })
    }
  }, {
    path: 'restore-password',
    name: 'restore-password',
    component: _restorePassword2.default,
    meta: {
      title: 'Restore Password - Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags.concat({
        property: 'og:title',
        content: 'Restore Password - Kung Food Chinese Takeaway'
      }, {
        property: 'og:url',
        content: 'https://kungfood.co.uk/restore-password'
      }, {
        property: 'twitter:title',
        content: 'Restore Password - Kung Food Chinese Takeaway'
      }, {
        property: 'twitter:url',
        content: 'https://kungfood.co.uk/restore-password'
      })
    }
  }, {
    path: 'set-password/:passwordToken',
    name: 'set-password',
    component: _setPassword2.default,
    meta: {
      title: 'Set Password - Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags.concat({
        property: 'og:title',
        content: 'Set Password - Kung Food Chinese Takeaway'
      }, {
        property: 'og:url',
        content: 'https://kungfood.co.uk/set-password'
      }, {
        property: 'twitter:title',
        content: 'Set Password - Kung Food Chinese Takeaway'
      }, {
        property: 'twitter:url',
        content: 'https://kungfood.co.uk/set-password'
      })
    },
    props: function props(route) {
      return {
        passwordToken: route.params.passwordToken
      };
    }
  }, {
    path: 'menu',
    name: 'menu',
    component: _menu2.default,
    meta: {
      title: 'Menu - Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags.concat({
        property: 'og:title',
        content: 'Menu - Kung Food Chinese Takeaway'
      }, {
        property: 'og:url',
        content: 'https://kungfood.co.uk/menu'
      }, {
        property: 'twitter:title',
        content: 'Menu - Kung Food Chinese Takeaway'
      }, {
        property: 'twitter:url',
        content: 'https://kungfood.co.uk/menu'
      })
    }
  }, {
    path: 'lunch-boxes',
    name: 'lunchBoxes',
    component: _lunchBoxes2.default,
    meta: {
      title: 'Lunch Boxes - Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags.concat({
        property: 'og:title',
        content: 'Lunch Boxes - Kung Food Chinese Takeaway'
      }, {
        property: 'og:url',
        content: 'https://kungfood.co.uk/lunch-boxes'
      }, {
        property: 'twitter:title',
        content: 'Lunch Boxes - Kung Food Chinese Takeaway'
      }, {
        property: 'twitter:url',
        content: 'https://kungfood.co.uk/lunch-boxes'
      })
    }
  }, {
    path: 'contact',
    name: 'contact',
    component: _contact2.default,
    meta: {
      title: 'Contact - Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags.concat({
        property: 'og:title',
        content: 'Contact - Kung Food Chinese Takeaway'
      }, {
        property: 'og:url',
        content: 'https://kungfood.co.uk/contact'
      }, {
        property: 'twitter:title',
        content: 'Contact - Kung Food Chinese Takeaway'
      }, {
        property: 'twitter:url',
        content: 'https://kungfood.co.uk/contact'
      })
    }
  }, {
    path: 'checkout',
    name: 'checkout',
    component: _checkout2.default,
    meta: {
      title: 'Checkout - Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags.concat({
        property: 'og:title',
        content: 'Checkout - Kung Food Chinese Takeaway'
      }, {
        property: 'og:url',
        content: 'https://kungfood.co.uk/checkout'
      }, {
        property: 'twitter:title',
        content: 'Checkout - Kung Food Chinese Takeaway'
      }, {
        property: 'twitter:url',
        content: 'https://kungfood.co.uk/checkout'
      })
    }
  }, {
    path: 'checkout-response',
    name: 'checkout-response',
    component: _response2.default,
    props: true,
    meta: {
      title: 'Checkout Response - Kung Food Chinese Takeaway',
      metaTags: defaultMetaTags
    }
  }]
}, {
  path: '*',
  component: _NotFoundPage2.default,
  meta: {
    title: 'Page Not Found - Kung Food Chinese Takeaway',
    metaTags: defaultMetaTags.concat({
      property: 'og:title',
      content: 'Page Not Found - Kung Food Chinese Takeaway'
    }, {
      property: 'twitter:title',
      content: 'Page Not Found - Kung Food Chinese Takeaway'
    })
  }
}];

exports.default = routes;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(63);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(23);

var _vuex2 = _interopRequireDefault(_vuex);

var _actions = __webpack_require__(377);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(378);

var _getters2 = _interopRequireDefault(_getters);

var _state = __webpack_require__(173);

var _state2 = _interopRequireDefault(_state);

var _mutations = __webpack_require__(379);

var _mutations2 = _interopRequireDefault(_mutations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
exports.default = new _vuex2.default.Store({
  actions: actions,
  getters: _getters2.default,
  state: _state2.default,
  mutations: _mutations2.default,
  strict: false
});

/***/ }),
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(498)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(559),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(63);

var _vue2 = _interopRequireDefault(_vue);

var _vueAxios = __webpack_require__(517);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _axios = __webpack_require__(358);

var _axios2 = _interopRequireDefault(_axios);

var _localStorage = __webpack_require__(71);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _env = __webpack_require__(56);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueAxios2.default, _axios2.default);

var webApi = _axios2.default.create({
  baseURL: _env2.default.api_base_url
});

webApi.interceptors.request.use(function (config) {
  var token = _localStorage2.default.get('token');
  if (token) {
    config.params = {
      token: token
    };
  }
  return config;
});

exports.default = {
  signin: function signin(data) {
    return webApi.post('auth/signin', data);
  },
  register: function register(data) {
    return webApi.post('auth/register', data);
  },
  getFeaturedProductsData: function getFeaturedProductsData(locationId) {
    return webApi.get('featured-products/' + locationId);
  },
  listMenu: function listMenu(locationId) {
    return webApi.get('list-menu/' + locationId);
  },
  listLunchBoxes: function listLunchBoxes(locationId) {
    return webApi.get('offers/' + locationId);
  },
  getSettings: function getSettings(locationId) {
    return webApi.get('settings/' + locationId);
  },
  getStatus: function getStatus() {
    return webApi.get('customer/status');
  },
  editCustomer: function editCustomer(data) {
    return webApi.post('customer/edit', data);
  },
  manageCustomerInCheckout: function manageCustomerInCheckout(data) {
    return webApi.post('manage-customer-in-checkout', data);
  },
  placeOrder: function placeOrder(data) {
    return webApi.post('place-order', data);
  },
  getOrder: function getOrder(data) {
    return webApi.post('get-order', data);
  },
  getCustomerPaymentSources: function getCustomerPaymentSources(locationId) {
    return webApi.get('customer/payment-sources?location_id=' + locationId);
  },
  deleteCustomerDefaultPaymentSource: function deleteCustomerDefaultPaymentSource(locationId) {
    return webApi.post('customer/delete-default-payment-source?location_id=' + locationId);
  },
  getCustomerOrders: function getCustomerOrders() {
    return webApi.get('customer/orders');
  },
  getDiscount: function getDiscount(code) {
    return webApi.get('get-discount?code=' + code);
  },
  sendMessage: function sendMessage(data) {
    return webApi.post('send-message', data);
  },
  restorePassword: function restorePassword(data) {
    return webApi.post('auth/restore-password', data);
  },
  setNewPassword: function setNewPassword(data) {
    return webApi.post('auth/set-new-password', data);
  },
  getCustomerByPasswordToken: function getCustomerByPasswordToken(data) {
    return webApi.post('auth/get-customer-by-password-token', data);
  }
};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(167);

var _keys2 = _interopRequireDefault(_keys);

var _from = __webpack_require__(346);

var _from2 = _interopRequireDefault(_from);

var _vue = __webpack_require__(63);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(357);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vClickOutside = __webpack_require__(355);

var _vClickOutside2 = _interopRequireDefault(_vClickOutside);

var _gloablComponents = __webpack_require__(343);

var _gloablComponents2 = _interopRequireDefault(_gloablComponents);

var _NotificationPlugin = __webpack_require__(342);

var _NotificationPlugin2 = _interopRequireDefault(_NotificationPlugin);

var _Notification = __webpack_require__(72);

var _Notification2 = _interopRequireDefault(_Notification);

var _App = __webpack_require__(356);

var _App2 = _interopRequireDefault(_App);

var _routes = __webpack_require__(344);

var _routes2 = _interopRequireDefault(_routes);

var _store = __webpack_require__(345);

var _store2 = _interopRequireDefault(_store);

var _chartist = __webpack_require__(348);

var _chartist2 = _interopRequireDefault(_chartist);

__webpack_require__(351);

__webpack_require__(350);

__webpack_require__(352);

__webpack_require__(349);

var _bootstrapVue = __webpack_require__(347);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _ravenJs = __webpack_require__(354);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _vue3 = __webpack_require__(353);

var _vue4 = _interopRequireDefault(_vue3);

var _env = __webpack_require__(56);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_gloablComponents2.default);
_vue2.default.use(_vClickOutside2.default);
_vue2.default.use(_NotificationPlugin2.default);
_vue2.default.use(_Notification2.default);
_vue2.default.use(_bootstrapVue2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  routes: _routes2.default,
  linkActiveClass: 'active'
});

router.beforeEach(function (to, from, next) {
  var nearestWithTitle = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.title;
  });

  var nearestWithMeta = to.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.metaTags;
  });
  var previousNearestWithMeta = from.matched.slice().reverse().find(function (r) {
    return r.meta && r.meta.metaTags;
  });

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;else if (previousNearestWithMeta) document.title = previousNearestWithMeta.meta.title;

  (0, _from2.default)(document.querySelectorAll('[data-vue-router-controlled]')).map(function (el) {
    return el.parentNode.removeChild(el);
  });

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(function (tagDef) {
    var tag = document.createElement('meta');

    (0, _keys2.default)(tagDef).forEach(function (key) {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  }).forEach(function (tag) {
    return document.head.appendChild(tag);
  });

  next();
});

router.afterEach(function (to, from, next) {
  setTimeout(function () {
    document.getElementById('mainPanel').scrollTo(0, 0);
  }, 200);
});

Object.defineProperty(_vue2.default.prototype, '$Chartist', {
  get: function get() {
    return this.$root.Chartist;
  }
});

_ravenJs2.default.config(_env2.default.sentry).addPlugin(_vue4.default, _vue2.default).install();

new _vue2.default({
  el: '#app',
  render: function render(h) {
    return h(_App2.default);
  },
  router: router,
  store: _store2.default,
  data: {
    Chartist: _chartist2.default
  }
});

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingOff = exports.LoadingOn = exports.SendMessage = exports.UpdateDiscount = exports.SetNewPassword = exports.GetCustomerByPasswordToken = exports.RestorePassword = exports.GetDiscount = exports.GetCustomerOrders = exports.DeleteCustomerDefaultPaymentSource = exports.GetCustomerPaymentSources = exports.EditCustomer = exports.GetSettings = exports.GetStatus = exports.UpdateOrderType = exports.UpdateCart = exports.SetLocation = exports.AuthSignout = exports.GetOrder = exports.PlaceOrder = exports.ManageCustomerInCheckout = exports.ListLunchBoxes = exports.ListMenu = exports.GetFeaturedProductsData = exports.Register = exports.Signin = undefined;

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(408);

var _promise2 = _interopRequireDefault(_promise);

var _types = __webpack_require__(174);

var types = _interopRequireWildcard(_types);

var _api = __webpack_require__(375);

var _api2 = _interopRequireDefault(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Signin = exports.Signin = function Signin(_ref, data) {
  var commit = _ref.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.signin(data).then(function (response) {
      commit(types.AUTH, (0, _extends3.default)({
        loggedInAt: new Date()
      }, response.data));
      resolve();
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var Register = exports.Register = function Register(_ref2, data) {
  var commit = _ref2.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.register(data).then(function (response) {
      commit(types.AUTH, (0, _extends3.default)({
        loggedInAt: new Date()
      }, response.data));
      resolve();
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var GetFeaturedProductsData = exports.GetFeaturedProductsData = function GetFeaturedProductsData(_ref3, locationId) {
  var commit = _ref3.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.getFeaturedProductsData(locationId).then(function (response) {
      commit(types.GENERAL_SETTINGS, response.data.kf_resources);
      resolve(response.data);
    }).catch(function (error) {
      console.log(error);
      reject(error.response.data);
    });
  });
  return promise;
};

var ListMenu = exports.ListMenu = function ListMenu(_ref4, locationId) {
  var commit = _ref4.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.listMenu(locationId).then(function (response) {
      commit(types.GENERAL_SETTINGS, response.data.kf_resources);
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var ListLunchBoxes = exports.ListLunchBoxes = function ListLunchBoxes(_ref5, locationId) {
  var commit = _ref5.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.listLunchBoxes(locationId).then(function (response) {
      commit(types.GENERAL_SETTINGS, response.data.kf_resources);
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var ManageCustomerInCheckout = exports.ManageCustomerInCheckout = function ManageCustomerInCheckout(_ref6, data) {
  var commit = _ref6.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.manageCustomerInCheckout(data).then(function (response) {
      if (!data.guest) {
        commit(types.AUTH, (0, _extends3.default)({
          loggedInAt: new Date()
        }, response.data));
      }
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var PlaceOrder = exports.PlaceOrder = function PlaceOrder(_ref7, data) {
  var commit = _ref7.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.placeOrder(data).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var GetOrder = exports.GetOrder = function GetOrder(_ref8, data) {
  var commit = _ref8.commit;

  return new _promise2.default(function (resolve, reject) {
    _api2.default.getOrder(data).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
};

var AuthSignout = exports.AuthSignout = function AuthSignout(_ref9) {
  var commit = _ref9.commit;

  commit(types.SIGNOUT);
};

var SetLocation = exports.SetLocation = function SetLocation(_ref10, payload) {
  var commit = _ref10.commit;

  commit(types.LOCATION, payload);
};

var UpdateCart = exports.UpdateCart = function UpdateCart(_ref11, payload) {
  var commit = _ref11.commit;

  commit(types.UPDATE_CART, payload);
};

var UpdateOrderType = exports.UpdateOrderType = function UpdateOrderType(_ref12, orderType) {
  var commit = _ref12.commit;

  commit(types.ORDER_TYPE, orderType);
};

var GetStatus = exports.GetStatus = function GetStatus(_ref13) {
  var commit = _ref13.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.getStatus().then(function (response) {
      commit(types.STATUS, response.data);
      resolve();
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var GetSettings = exports.GetSettings = function GetSettings(_ref14, locationId) {
  var commit = _ref14.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.getSettings(locationId).then(function (response) {
      commit(types.GENERAL_SETTINGS, response.data);
      resolve();
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var EditCustomer = exports.EditCustomer = function EditCustomer(_ref15, data) {
  var commit = _ref15.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.editCustomer(data).then(function (response) {
      commit(types.STATUS, response.data);
      resolve();
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var GetCustomerPaymentSources = exports.GetCustomerPaymentSources = function GetCustomerPaymentSources(_ref16, locationId) {
  var commit = _ref16.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.getCustomerPaymentSources(locationId).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var DeleteCustomerDefaultPaymentSource = exports.DeleteCustomerDefaultPaymentSource = function DeleteCustomerDefaultPaymentSource(_ref17, locationId) {
  var commit = _ref17.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.deleteCustomerDefaultPaymentSource(locationId).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var GetCustomerOrders = exports.GetCustomerOrders = function GetCustomerOrders(_ref18) {
  var commit = _ref18.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.getCustomerOrders().then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var GetDiscount = exports.GetDiscount = function GetDiscount(_ref19, code) {
  var commit = _ref19.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.getDiscount(code).then(function (response) {
      commit(types.DISCOUNT, response.data);
      resolve(response.data);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var RestorePassword = exports.RestorePassword = function RestorePassword(_ref20, data) {
  var commit = _ref20.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.restorePassword(data).then(function () {
      resolve();
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var GetCustomerByPasswordToken = exports.GetCustomerByPasswordToken = function GetCustomerByPasswordToken(_ref21, data) {
  var commit = _ref21.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.getCustomerByPasswordToken(data).then(function (response) {
      resolve(response.data.customer);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var SetNewPassword = exports.SetNewPassword = function SetNewPassword(_ref22, data) {
  var commit = _ref22.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.setNewPassword(data).then(function () {
      resolve();
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var UpdateDiscount = exports.UpdateDiscount = function UpdateDiscount(_ref23, discount) {
  var commit = _ref23.commit;

  var nullDiscount = {
    code: null,
    amount: null,
    type: null
  };

  if (discount) {
    commit(types.DISCOUNT, discount);
  } else {
    commit(types.DISCOUNT, nullDiscount);
  }
};

var SendMessage = exports.SendMessage = function SendMessage(_ref24, data) {
  var commit = _ref24.commit;

  var promise = new _promise2.default(function (resolve, reject) {
    _api2.default.sendMessage(data).then(function () {
      resolve();
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
  return promise;
};

var LoadingOn = exports.LoadingOn = function LoadingOn(_ref25) {
  var commit = _ref25.commit;

  commit(types.LOADING_ON);
};
var LoadingOff = exports.LoadingOff = function LoadingOff(_ref26) {
  var commit = _ref26.commit;

  commit(types.LOADING_OFF);
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _localStorage = __webpack_require__(71);

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  getLocation: function getLocation(state, getters) {
    return function (locationId) {
      switch (locationId) {
        case 1:
          {
            return {
              id: 1,
              name: 'Liverpool Street',
              postcode: 'EC2'
            };
          }
        case 2:
          {
            return {
              id: 1,
              name: 'Clerkenwell',
              postcode: 'EC1'
            };
          }
      }
    };
  },
  getCartTotal: function getCartTotal(state, getters) {
    var cart = state.cart;

    var total = 0;

    cart.forEach(function (row) {
      total = total + (row.discount > 0 ? row.discount : row.price) * row.quantity;
    });

    return total;
  },
  getOrderType: function getOrderType(state, getters) {
    var orderType = _localStorage2.default.get('orderType');
    if (orderType && state.websiteAvailability.canDoDelivery === true) {
      return orderType;
    }
    return 'collection';
  },
  infoPopupOpened: function infoPopupOpened(state, getters) {
    var popupOpened = _localStorage2.default.get('infoPopupOpened');

    if (popupOpened !== null) {
      return popupOpened;
    }

    return true;
  }
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(409);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _types$AUTH$types$SIG;

var _localStorage = __webpack_require__(71);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _types = __webpack_require__(174);

var types = _interopRequireWildcard(_types);

var _state = __webpack_require__(173);

var _state2 = _interopRequireDefault(_state);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_types$AUTH$types$SIG = {}, (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.AUTH, function (commit, payload) {
  if (payload.token) {
    _localStorage2.default.set('user', payload);
    _localStorage2.default.set('token', payload.token);
    _state2.default.user = payload;
    _state2.default.token = payload.token;
  }
}), (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.SIGNOUT, function () {
  _localStorage2.default.remove('user');
  _localStorage2.default.remove('token');
  _state2.default.user = null;
  _state2.default.token = null;
}), (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.STATUS, function (commit, payload) {
  if (payload.customer.token) {
    _localStorage2.default.set('user', payload.customer);
    _localStorage2.default.set('token', payload.customer.token);
    _state2.default.user = payload.customer;
    _state2.default.token = payload.customer.token;
  }
}), (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.UPDATE_CART, function (commit, payload) {
  _localStorage2.default.set('cart', payload);
  _state2.default.cart = payload;
}), (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.ORDER_TYPE, function (commit, orderType) {
  _localStorage2.default.set('orderType', orderType);
  _state2.default.orderType = orderType;
}), (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.LOCATION, function (commit, payload) {
  _localStorage2.default.set('location', payload);
  _state2.default.location = payload;
}), (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.DISCOUNT, function (commit, payload) {
  _state2.default.discount = {
    code: payload.code,
    amount: payload.discount,
    type: payload.type
  };
}), (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.LOADING_ON, function () {
  _state2.default.isLoading = true;
}), (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.LOADING_OFF, function () {
  _state2.default.isLoading = false;
}), (0, _defineProperty3.default)(_types$AUTH$types$SIG, types.GENERAL_SETTINGS, function (commit, payload) {
  if (payload.minimum_for_delivery) {
    _state2.default.deliveryCost = payload.delivery_cost;
    _state2.default.adminFee = payload.admin_fee;
    _state2.default.discountThreshold = payload.discount_threshold;
    _state2.default.minimumForDelivery = payload.minimum_for_delivery;
    _state2.default.websiteAvailability = {
      isOpen: payload.is_open,
      nextOpeningHour: payload.next_opening_hour,
      nextOpeningDay: payload.next_opening_day,
      canTakeOrders: payload.can_take_orders,
      canDoDelivery: payload.can_do_delivery
    };
    if (_state2.default.location) {
      _state2.default.websiteContacts = {
        email: payload.email,
        phone: payload['phone'],
        address: payload['address']
      };
    }

    _state2.default.socials = {
      facebook: payload.facebook,
      instagram: payload.instagram,
      twitter: payload.twitter,
      youtube: payload.youtube
    };
  }
}), _types$AUTH$types$SIG);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    isLoading: function isLoading(state) {
      return state.isLoading;
    }
  }))
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    websiteContacts: function websiteContacts(state) {
      return state.websiteContacts;
    },
    socials: function socials(state) {
      return state.socials;
    }
  }))
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TopNavbar = __webpack_require__(523);

var _TopNavbar2 = _interopRequireDefault(_TopNavbar);

var _ContentFooter = __webpack_require__(520);

var _ContentFooter2 = _interopRequireDefault(_ContentFooter);

var _Content = __webpack_require__(519);

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    TopNavbar: _TopNavbar2.default,
    ContentFooter: _ContentFooter2.default,
    Content: _Content2.default
  },
  methods: {}
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

var _cartPopup = __webpack_require__(527);

var _cartPopup2 = _interopRequireDefault(_cartPopup);

var _Notification = __webpack_require__(72);

var _Notification2 = _interopRequireDefault(_Notification);

var _closedLocationNotice = __webpack_require__(340);

var _closedLocationNotice2 = _interopRequireDefault(_closedLocationNotice);

var _localStorage = __webpack_require__(71);

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var kf = void 0;
var checkCustomerInterval = null;

exports.default = {
  name: 'top-navbar',
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    token: function token(state) {
      return state.token;
    },
    user: function user(state) {
      return state.user;
    },
    location: function location(state) {
      return state.location;
    },
    cart: function cart(state) {
      return state.cart;
    },
    websiteAvailability: function websiteAvailability(state) {
      return state.websiteAvailability;
    }
  }), (0, _vuex.mapGetters)({
    getLocation: 'getLocation',
    getCartTotal: 'getCartTotal',
    infoPopupOpened: 'infoPopupOpened'
  })),
  data: function data() {
    return {
      locationName: 'Not Selected',
      showCart: null,
      toggleMenuVisible: false,
      informationPopupOpened: false
    };
  },
  created: function created() {
    if (!this.location) {
      this.$router.push({ name: 'select-location' });
    } else {
      this.locationName = this.getLocation(this.location.id).name;
    }
  },
  mounted: function mounted() {
    console.log(this.infoPopupOpened);
    this.informationPopupOpened = Boolean(this.infoPopupOpened);
    this.$store.dispatch('GetSettings', this.location.id);

    if (this.token) {
      checkCustomerInterval = setInterval(function () {
        kf.checkForCustomer();
      }, 30000);
    }

    kf = this;
  },

  methods: {
    changeLocation: function changeLocation() {
      kf.$router.push({ name: 'select-location' });
    },
    closeShowCart: function closeShowCart() {
      kf.showCart = false;
    },
    closeInfoPopup: function closeInfoPopup() {
      kf.informationPopupOpened = false;
      _localStorage2.default.set('infoPopupOpened', false);
    },
    checkForCustomer: function checkForCustomer() {
      if (kf.user) {
        kf.$store.dispatch('GetStatus').catch(function () {
          kf.notifyVue('danger', 'An error has been produced and you were logged off. Please try to authenticate back.');
          clearInterval(checkCustomerInterval);
          checkCustomerInterval = null;
          kf.$store.dispatch('AuthSignout');
        });
      } else {
        clearInterval(checkCustomerInterval);
        checkCustomerInterval = null;
      }
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  },
  watch: {
    '$route': function $route() {
      kf.checkForCustomer();

      if (!checkCustomerInterval) {
        checkCustomerInterval = setInterval(function () {
          kf.checkForCustomer();
        }, 30000);
      }
    }
  },
  components: {
    CartPopup: _cartPopup2.default,
    Notification: _Notification2.default,
    ClosedLocationNotice: _closedLocationNotice2.default
  }
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    title: String,
    icon: String
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    name: String,
    disabled: Boolean,
    placeholder: String,
    value: [String, Number]
  }
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'notification',
  props: {
    message: String,
    icon: String,
    verticalAlign: {
      type: String,
      default: 'top'
    },
    horizontalAlign: {
      type: String,
      default: 'center'
    },
    type: {
      type: String,
      default: 'info'
    },
    timeout: {
      type: Number,
      default: 2000
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    hasIcon: function hasIcon() {
      return this.icon && this.icon.length > 0;
    },
    alertType: function alertType() {
      return 'alert-' + this.type;
    },
    customPosition: function customPosition() {
      var _this = this;

      var initialMargin = 20;
      var alertHeight = 90;
      var sameAlertsCount = this.$notifications.state.filter(function (alert) {
        return alert.horizontalAlign === _this.horizontalAlign && alert.verticalAlign === _this.verticalAlign;
      }).length;
      var pixels = (sameAlertsCount - 1) * alertHeight + initialMargin;
      var styles = {};
      if (this.verticalAlign === 'top') {
        styles.top = pixels + 'px';
      } else {
        styles.bottom = pixels + 'px';
      }
      return styles;
    }
  },
  methods: {
    close: function close() {
      this.$emit('on-close');
    }
  },
  mounted: function mounted() {
    if (this.timeout) {
      setTimeout(this.close, this.timeout);
    }
  }
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Notification = __webpack_require__(72);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Notification: _Notification2.default
  },
  data: function data() {
    return {
      notifications: this.$notifications.state
    };
  },

  methods: {
    removeNotification: function removeNotification(index) {
      this.$notifications.removeNotification(index);
    }
  }
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

var _Notification = __webpack_require__(72);

var _Notification2 = _interopRequireDefault(_Notification);

var _env = __webpack_require__(56);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var kf = void 0;

exports.default = {
  name: 'cart-popup',
  props: ['showCart'],
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    cart: function cart(state) {
      return state.cart;
    }
  }), (0, _vuex.mapGetters)(['getCartTotal'])),
  mounted: function mounted() {
    kf = this;
  },
  data: function data() {
    return {
      base_url: _env2.default.base_url,
      showFullList: false
    };
  },

  methods: {
    closeCartPopup: function closeCartPopup() {
      kf.showCart = false;
      kf.$emit('closeShowCart');
    },
    deleteProductFromCart: function deleteProductFromCart(key) {
      if (confirm('Are you sure you want to remove this product from the cart?')) {
        kf.cart.splice(key, 1);
        kf.$store.dispatch('UpdateCart', kf.cart);
      }
    },
    goToCheckout: function goToCheckout() {
      kf.closeCartPopup();
      kf.$router.push({ name: 'checkout' });
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  },
  components: {
    Notification: _Notification2.default
  }
};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'closed-location-notice'
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var kf = void 0;

exports.default = {
  name: 'discount-popup',
  props: ['popupAfterTime'],
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    discount: function discount(state) {
      return state.discount;
    }
  })),
  mounted: function mounted() {
    kf = this;

    if (this.discount.type) {
      return;
    }

    setTimeout(function () {
      if (kf.discount.type) {
        return;
      }

      kf.showPopup = true;
    }, this.popupAfterTime ? this.popupAfterTime * 1000 : 10000);
  },
  data: function data() {
    return {
      showPopup: null
    };
  },

  methods: {
    closePopup: function closePopup() {
      kf.showPopup = false;
    },
    setDiscount: function setDiscount() {
      kf.$store.dispatch('UpdateDiscount', {
        code: 'V21CU23',
        discount: 10,
        type: '%'
      });
      kf.closePopup();

      kf.notifyVue('success', 'Your 10% discount has been applied. Now add products to your cart and enjoy the food!');

      kf.$router.push({ name: 'menu' });
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  }
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

var _env = __webpack_require__(56);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stripe = null;
var card = null;
var expressStripe = null;
var expressElements = null;
var expressCheckout = null;

var kf = void 0;
exports.default = {
  name: 'checkout',
  data: function data() {
    return {
      base_url: _env2.default.base_url,
      orderType: this.$store.getters.getOrderType,
      paymentType: 'card',
      checkoutMode: 'account',
      walletType: null,
      firstName: null,
      lastName: null,
      password: null,
      passwordConfirmation: null,
      email: null,
      phone: null,
      postcode: null,
      address: null,
      note: null,
      formError: null,
      topError: null,
      sources: null,
      bottomError: null,
      billing: {
        nameOnCard: null,
        postcode: null,
        address: null
      },
      billingError: {
        nameOnCard: null,
        postcode: null,
        address: null
      },

      saveCard: true,
      hasCard: null,
      sidebarOnAbsolute: false,
      billingAsShipping: true,
      paymentErrorMessage: null,
      coupon_code: null,

      currentHour: new Date().getHours(),
      currentMinute: new Date().getMinutes() < 9 ? '0' + new Date().getMinutes() : new Date().getMinutes(),
      sideCartVisible: false,
      canUseWallet: false
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    token: function token(state) {
      return state.token;
    },
    user: function user(state) {
      return state.user;
    },
    cart: function cart(state) {
      return state.cart;
    },
    deliveryCost: function deliveryCost(state) {
      return state.deliveryCost;
    },
    adminFee: function adminFee(state) {
      return state.adminFee;
    },
    discountThreshold: function discountThreshold(state) {
      return state.discountThreshold;
    },
    minimumForDelivery: function minimumForDelivery(state) {
      return state.minimumForDelivery;
    },
    location: function location(state) {
      return state.location;
    },
    websiteAvailability: function websiteAvailability(state) {
      return state.websiteAvailability;
    },
    discount: function discount(state) {
      return state.discount;
    }
  }), (0, _vuex.mapGetters)(['getCartTotal', 'getOrderType']), {
    cartTotalBeforeAdminFee: function cartTotalBeforeAdminFee() {
      var total = this.getCartTotal;

      if (this.discountThreshold < total) {
        if (this.discount.type === '%') {
          total = total - total * this.discount.amount / 100;
        } else if (this.discount.type === '£') {
          total = this.discount.amount > total ? 0 : total - this.discount.amount;
        }
      }

      return total + (this.orderType === 'collection' ? 0 : this.deliveryCost);
    },
    getCartFinalTotal: function getCartFinalTotal() {
      var total = this.cartTotalBeforeAdminFee;

      return total + (total < 10 && total > 0 ? this.adminFee : 0);
    },
    walletReady: function walletReady() {
      if (this.orderType === 'collection') {
        return true;
      }

      return !!this.token;
    },
    walletLabel: function walletLabel() {
      if (this.walletType === 'applePay') {
        return 'Apple Pay';
      }
      if (this.walletType === 'googlePay') {
        return 'Google Pay';
      }
      return 'Apple Pay / Google Pay';
    },
    isGuestMode: function isGuestMode() {
      return !this.token && this.checkoutMode === 'guest' && this.orderType === 'collection';
    },
    showCardForm: function showCardForm() {
      return this.hasCard !== null;
    }
  }),
  watch: {
    orderType: function orderType(val) {
      kf.$store.dispatch('UpdateOrderType', val);
      if (val === 'delivery' && kf.checkoutMode === 'guest') {
        kf.checkoutMode = 'account';
      }
      kf.billingAsShipping = val === 'delivery';
      kf.destroyExpressCheckout();
      kf.$nextTick(kf.initializeExpressCheckout);
    },
    getCartFinalTotal: function getCartFinalTotal() {
      if (expressElements) {
        expressElements.update({ amount: kf.walletAmount() });
      }
    }
  },
  created: function created() {
    kf = this;
    if (this.user) {
      this.firstName = this.user.first_name;
      this.lastName = this.user.last_name;
      this.email = this.user.email;
      this.phone = this.user.phone;
      this.address = this.user.address1;
      this.postcode = this.user.postcode;
      this.billing.address = this.user.address1;
      this.billing.postcode = this.user.postcode;
      this.billing.nameOnCard = this.user.first_name + ' ' + this.user.last_name;
    }
    kf.coupon_code = kf.discount.code ? kf.discount.code : null;

    if (this.currentHour + '' + this.currentMinute < '1600') {
      this.orderType = 'collection';
    }

    this.billingAsShipping = this.orderType === 'delivery';
  },
  mounted: function mounted() {
    this.initializePayment();
    this.initializeExpressCheckout();
  },

  methods: {
    deleteProductFromCart: function deleteProductFromCart(key) {
      if (confirm('Are you sure you want to remove this product from the cart?')) {
        kf.cart.splice(key, 1);
        kf.$store.dispatch('UpdateCart', kf.cart);
      }
    },
    initializePayment: function initializePayment() {
      if (kf.user) {
        kf.$store.dispatch('GetCustomerPaymentSources', kf.location.id).then(function (response) {
          kf.sources = response.sources;
          if (response.sources.length) {
            kf.placeOrderWithoutStripe();
            kf.hasCard = true;
          } else {
            kf.initializeStripe();
          }
        }).catch(function (error) {
          console.log(error);
          kf.initializeStripe();
        });
      } else {
        kf.initializeStripe();
      }
    },
    initializeStripe: function initializeStripe() {
      kf.hasCard = false;

      setTimeout(function () {
        stripe = Stripe(kf.location.id === 1 ? _env2.default.stripe_token_location_1 : _env2.default.stripe_token_location_2);

        var elements = stripe.elements({
          hidePostalCode: true,
          fonts: [{
            family: 'Muli',
            src: 'local("Muli Bold"), local("Muli-Bold"), url(https://fonts.gstatic.com/s/muli/v11/7Au_p_0qiz-adYnjOCX2z24PMFk.woff2) format("woff2")',
            style: 'normal',
            weight: 700,
            unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
          }]
        });

        var style = {
          base: {
            color: '#32325d',
            lineHeight: '18px',
            fontSmoothing: 'antialiased',
            fontFamily: '"Muli", Helvetica, sans-serif',
            fontSize: '14px',
            '::placeholder': {
              color: '#dfe2e4'
            }
          },
          invalid: {
            color: '#fa755a',
            iconColor: '#fa755a'
          }
        };

        card = elements.create('card', {
          hidePostalCode: true,
          style: style
        });

        card.mount('#card-element');

        card.addEventListener('change', function (event) {
          var displayError = document.getElementById('card-errors');
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = '';
          }
        });

        var form = document.getElementById('payment-form');
        form.addEventListener('submit', kf.placeOrderWithStripeEvent, true);
      }, 300);
    },
    placeOrderWithStripeEvent: function placeOrderWithStripeEvent(event) {
      event.preventDefault();

      if (kf.paymentType === 'wallet') {
        kf.notifyVue('danger', 'Please use ' + kf.walletLabel + ' to complete your order.');
        return;
      }

      if (kf.paymentType === 'wallet') {
        kf.notifyVue('danger', 'Please use ' + kf.walletLabel + ' to complete your order.');
        return;
      }

      var isGuest = kf.isGuestMode;
      var guestName = kf.splitName(kf.billing.nameOnCard);

      kf.$store.dispatch('LoadingOn');

      kf.$store.dispatch('ManageCustomerInCheckout', {
        guest: isGuest,
        first_name: isGuest ? guestName.first : kf.firstName,
        last_name: isGuest ? guestName.last : kf.lastName,
        email: kf.email,
        phone: kf.phone,
        password: isGuest ? null : kf.password,
        password_confirmation: isGuest ? null : kf.passwordConfirmation,
        address: kf.address ? kf.address : kf.billing.address ? kf.billing.address : null,
        postcode: kf.postcode ? kf.postcode : kf.billing.postcode ? kf.billing.postcode : null,
        order_type: kf.orderType
      }).then(function (response) {
        kf.placeOrderWithStripe(stripe, card, response);
      }).catch(function (error) {
        console.log(error);
        kf.notifyVue('danger', 'Please check your details once again.');

        kf.formError = {
          firstName: error.errors.first_name ? error.errors.first_name.join(' ') : null,
          lastName: error.errors.last_name ? error.errors.last_name.join(' ') : null,
          email: error.errors.email ? error.errors.email.join(' ') : null,
          postcode: error.errors.postcode ? error.errors.postcode.join(' ') : null,
          phone: error.errors.phone ? error.errors.phone.join(' ') : null,
          password: error.errors.password ? error.errors.password.join(' ') : null,
          address: error.errors.address ? error.errors.address.join(' ') : null
        };

        console.log(error);

        kf.$store.dispatch('LoadingOff');
      });
    },
    placeOrderWithStripe: function placeOrderWithStripe(stripe, card, customer) {
      var shippingName = [kf.firstName, kf.lastName].filter(Boolean).join(' ');

      var extraDetails = {
        name: kf.billingAsShipping ? shippingName : kf.billing.nameOnCard,
        address_zip: kf.billingAsShipping && kf.orderType === 'delivery' ? kf.postcode : kf.billing.postcode,
        address_line1: kf.billingAsShipping && kf.orderType === 'delivery' ? kf.address : kf.billing.address,
        address_country: 'United Kingdom'
      };

      kf.billingError = {
        nameOnCard: extraDetails.name ? null : 'Name on card is missing.',
        postcode: extraDetails.address_zip ? null : 'Postcode is missing.',
        address: extraDetails.address_line1 ? null : 'Address is missing.'
      };

      if (kf.billingError.nameOnCard || kf.billingError.postcode || kf.billingError.address) {
        kf.$store.dispatch('LoadingOff');
        kf.notifyVue('danger', 'Please check your billing details.');

        return;
      }

      stripe.createToken(card, extraDetails).then(function (result) {
        var _this = this;

        if (result.error) {
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
          kf.$store.dispatch('LoadingOff');
        } else {
          if (typeof result.token === 'undefined' || result.token === null || result.token === '') {
            kf.notifyVue('danger', 'Something went wrong with your card. Please try again..');
            kf.$store.dispatch('LoadingOff');
            return;
          }

          kf.$store.dispatch('PlaceOrder', {
            token: customer && customer.is_guest ? customer.token : undefined,
            stripe_token: result.token,
            save_card: customer && customer.is_guest ? false : kf.saveCard,
            expected_total: kf.getCartFinalTotal,
            order_type: kf.orderType,
            address: kf.deliveryAddress(),
            postcode: kf.deliveryPostcode(),
            cart: kf.cart,
            note: kf.note,
            discount: kf.discount,
            location: kf.location,
            payment_type: 'card'
          }).then(function (response) {
            if (response.payment_intent.next_action && response.payment_intent.next_action.redirect_to_url) {
              window.location = decodeURI(response.payment_intent.next_action.redirect_to_url.url);
            } else {
              kf.$router.push('/checkout-response?payment_intent=' + response.payment_intent.id);
            }
          }).catch(function (error) {
            if (error.message) {
              kf.notifyVue('danger', error.message);
              _this.bottomError = error.message;
            } else if (error.errors.length > 0) {
              kf.paymentErrorMessage = error.errors.join(' ');
            } else {
              kf.notifyVue('danger', 'Something went wrong. Please try again.');
              _this.bottomError = 'Something went wrong. Please try again.';
            }
            kf.$store.dispatch('LoadingOff');
          });
        }
      });
    },
    placeOrderWithoutStripe: function placeOrderWithoutStripe() {
      var form = document.getElementById('payment-form');
      form.addEventListener('submit', kf.placeOrderWithoutStripeForm, true);
    },
    placeOrderWithoutStripeForm: function placeOrderWithoutStripeForm(event) {
      var _this2 = this;

      event.preventDefault();
      kf.$store.dispatch('LoadingOn');

      kf.$store.dispatch('PlaceOrder', {
        expected_total: kf.getCartFinalTotal,
        order_type: kf.orderType,
        address: kf.deliveryAddress(),
        postcode: kf.deliveryPostcode(),
        cart: kf.cart,
        note: kf.note,
        discount: kf.discount,
        location: kf.location,
        payment_type: 'card'
      }).then(function (response) {
        if (response.payment_intent.next_action && response.payment_intent.next_action.redirect_to_url) {
          window.location = decodeURI(response.payment_intent.next_action.redirect_to_url.url);
        } else {
          kf.$router.push('/checkout-response?payment_intent=' + response.payment_intent.id);
        }
      }).catch(function (error) {
        if (error.message) {
          kf.notifyVue('danger', error.message);
          _this2.bottomError = error.message;
        } else if (error.errors.length > 0) {
          kf.paymentErrorMessage = error.errors.join(' ');
        } else {
          kf.notifyVue('danger', 'Something went wrong. Please try again.');
          _this2.bottomError = 'Something went wrong. Please try again.';
        }
        kf.$store.dispatch('LoadingOff');
      });
    },
    addNewCard: function addNewCard() {
      var form = document.getElementById('payment-form');
      form.removeEventListener('submit', kf.placeOrderWithoutStripeForm, true);
      kf.initializeStripe();
    },
    changePaymentType: function changePaymentType() {
      var form = document.getElementById('payment-form');

      setTimeout(function () {
        if (kf.paymentType === 'card') {
          form.removeEventListener('submit', kf.placeOrderWithPayByCash, true);
          kf.initializePayment();
        } else {
          form.removeEventListener('submit', kf.placeOrderWithStripeEvent, true);
          form.removeEventListener('submit', kf.placeOrderWithoutStripeForm, true);
          form.addEventListener('submit', kf.placeOrderWithPayByCash, true);
        }
      }, 100);
    },
    placeOrderWithPayByCash: function placeOrderWithPayByCash(event) {
      var _this3 = this;

      event.preventDefault();
      kf.$store.dispatch('LoadingOn');

      kf.$store.dispatch('ManageCustomerInCheckout', {
        first_name: kf.firstName,
        last_name: kf.lastName,
        email: kf.email,
        phone: kf.phone,
        password: kf.password,
        password_confirmation: kf.passwordConfirmation,
        address: kf.address ? kf.address : kf.billing.address ? kf.billing.address : null,
        postcode: kf.postcode ? kf.postcode : kf.billing.postcode ? kf.billing.postcode : null,
        order_type: kf.orderType
      }).then(function (response) {
        kf.$store.dispatch('PlaceOrder', {
          expected_total: kf.getCartFinalTotal,
          order_type: kf.orderType,
          address: kf.deliveryAddress(),
          postcode: kf.deliveryPostcode(),
          cart: kf.cart,
          note: kf.note,
          discount: kf.discount,
          location: kf.location,
          payment_type: 'cash'
        }).then(function (response) {
          kf.$router.push('/checkout-response?order_number=' + response.order_number);
        }).catch(function (error) {
          if (error.message) {
            kf.notifyVue('danger', error.message);
            _this3.bottomError = error.message;
          } else {
            kf.notifyVue('danger', 'Something went wrong. Please try again.');
            _this3.bottomError = 'Something went wrong. Please try again.';
          }
          kf.$store.dispatch('LoadingOff');
        });
      }).catch(function (error) {
        console.log(error);
        kf.notifyVue('danger', 'Please check your details once again.');

        kf.formError = {
          firstName: error.errors.first_name ? error.errors.first_name.join(' ') : null,
          lastName: error.errors.last_name ? error.errors.last_name.join(' ') : null,
          email: error.errors.email ? error.errors.email.join(' ') : null,
          postcode: error.errors.postcode ? error.errors.postcode.join(' ') : null,
          phone: error.errors.phone ? error.errors.phone.join(' ') : null,
          password: error.errors.password ? error.errors.password.join(' ') : null,
          address: error.errors.address ? error.errors.address.join(' ') : null
        };

        console.log(error);

        kf.$store.dispatch('LoadingOff');
      });
    },
    applyCoupon: function applyCoupon() {
      if (kf.coupon_code === null || kf.coupon_code === '') {
        kf.notifyVue('danger', 'Please enter a discount code.');
        return;
      }

      kf.$store.dispatch('GetDiscount', kf.coupon_code).then(function (response) {
        kf.notifyVue('success', 'You successfully applied your coupon.');
      }).catch(function (error) {
        kf.notifyVue('danger', error.errors.length ? error.errors[0] : 'Something went wrong. Please try again.');
      });
    },
    plusProductQuantity: function plusProductQuantity(index) {
      var product = kf.cart[index];

      product.quantity++;
      kf.cart[index] = product;

      kf.$store.dispatch('UpdateCart', kf.cart);
    },
    minusProductQuantity: function minusProductQuantity(index) {
      var product = kf.cart[index];

      if (product.quantity > 1) {
        product.quantity--;
        kf.cart[index] = product;

        kf.$store.dispatch('UpdateCart', kf.cart);
      }
    },
    deliveryAddress: function deliveryAddress() {
      return kf.address ? kf.address : kf.user && kf.user.address1 ? kf.user.address1 : null;
    },
    deliveryPostcode: function deliveryPostcode() {
      return kf.postcode ? kf.postcode : kf.user && kf.user.postcode ? kf.user.postcode : null;
    },
    walletAmount: function walletAmount() {
      return Math.round(kf.getCartFinalTotal * 100);
    },
    initializeExpressCheckout: function initializeExpressCheckout() {
      if (_env2.default.wallet_enabled === false || !kf.cart.length || !kf.walletReady) {
        return;
      }

      expressStripe = Stripe(kf.location.id === 1 ? _env2.default.stripe_token_location_1 : _env2.default.stripe_token_location_2);

      expressElements = expressStripe.elements({
        mode: 'payment',
        amount: kf.walletAmount(),
        currency: 'gbp',
        paymentMethodTypes: ['card'],
        appearance: {
          variables: {
            fontFamily: '"Muli", Helvetica, sans-serif'
          }
        }
      });

      expressCheckout = expressElements.create('expressCheckout', {
        buttonHeight: 48,
        business: { name: 'KungFood' },
        emailRequired: true,
        phoneNumberRequired: true,
        billingAddressRequired: true,
        shippingAddressRequired: false,
        paymentMethods: {
          applePay: 'auto',
          googlePay: 'auto',
          link: 'never',
          paypal: 'never',
          amazonPay: 'never'
        },
        layout: {
          maxColumns: 2,
          overflow: 'never'
        }
      });

      expressCheckout.on('ready', function (event) {
        var available = event && event.availablePaymentMethods;

        kf.canUseWallet = !!available;

        if (!available) {
          kf.paymentType = 'card';
          return;
        }

        kf.walletType = available.applePay ? 'applePay' : available.googlePay ? 'googlePay' : null;
      });

      expressCheckout.on('loaderror', function (event) {
        kf.canUseWallet = false;
      });

      expressCheckout.on('click', function (event) {
        event.resolve({});
      });

      expressCheckout.on('confirm', kf.handleExpressCheckoutConfirm);

      expressCheckout.mount('#express-checkout-element');
    },
    destroyExpressCheckout: function destroyExpressCheckout() {
      if (expressCheckout) {
        expressCheckout.unmount();
      }

      expressCheckout = null;
      expressElements = null;
      kf.canUseWallet = false;
    },
    splitName: function splitName(fullName) {
      var parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
      var first = parts.shift() || null;

      return { first: first, last: parts.length ? parts.join(' ') : first };
    },
    handleExpressCheckoutConfirm: function handleExpressCheckoutConfirm(event) {
      kf.$store.dispatch('LoadingOn');

      expressElements.submit().then(function (result) {
        if (result.error) {
          throw result.error;
        }

        var billingDetails = event.billingDetails || {};
        var name = kf.splitName(billingDetails.name);
        var isGuest = !kf.token && kf.orderType === 'collection' && (kf.isGuestMode || !kf.password);

        var address = kf.address ? kf.address : kf.billing.address ? kf.billing.address : null;
        var postcode = kf.postcode ? kf.postcode : kf.billing.postcode ? kf.billing.postcode : null;

        if (billingDetails.address) {
          address = address || [billingDetails.address.line1, billingDetails.address.line2].filter(Boolean).join(', ') || null;
          postcode = postcode || billingDetails.address.postal_code || null;
        }

        return kf.$store.dispatch('ManageCustomerInCheckout', {
          guest: isGuest,
          first_name: kf.firstName ? kf.firstName : name.first,
          last_name: kf.lastName ? kf.lastName : name.last,
          email: kf.email ? kf.email : billingDetails.email,
          phone: kf.phone ? kf.phone : billingDetails.phone,
          password: isGuest ? null : kf.password,
          password_confirmation: isGuest ? null : kf.passwordConfirmation,
          address: address,
          postcode: postcode,
          order_type: kf.orderType
        }).then(function (customer) {
          return kf.$store.dispatch('PlaceOrder', {
            token: customer && customer.is_guest ? customer.token : undefined,
            deferred_payment: true,
            save_card: false,
            expected_total: kf.getCartFinalTotal,
            order_type: kf.orderType,
            address: kf.deliveryAddress(),
            postcode: kf.deliveryPostcode(),
            cart: kf.cart,
            note: kf.note,
            discount: kf.discount,
            location: kf.location,
            payment_type: 'card'
          });
        });
      }).then(function (response) {
        return expressStripe.confirmPayment({
          elements: expressElements,
          clientSecret: response.payment_intent.client_secret,
          confirmParams: {
            return_url: window.location.origin + '/checkout-response'
          },
          redirect: 'if_required'
        });
      }).then(function (confirmation) {
        if (confirmation.error) {
          throw confirmation.error;
        }

        kf.$router.push('/checkout-response?payment_intent=' + confirmation.paymentIntent.id);
      }).catch(function (error) {
        kf.$store.dispatch('LoadingOff');

        if (typeof event.paymentFailed === 'function') {
          event.paymentFailed({ reason: 'fail' });
        }

        if (error && error.message) {
          kf.notifyVue('danger', error.message);
        } else if (error && error.errors && error.errors.length > 0) {
          kf.paymentErrorMessage = error.errors.join(' ');
        } else {
          kf.notifyVue('danger', 'Something went wrong. Please try again.');
        }
      });
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  }
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var kf = void 0;

exports.default = {
  name: 'checkout-response',
  data: function data() {
    return {
      paymentIntentId: null,
      orderNumber: null,
      order: null
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    user: function user(state) {
      return state.user;
    }
  })),
  created: function created() {
    kf = this;
    this.$store.dispatch('LoadingOn');
  },
  beforeMount: function beforeMount() {
    kf.paymentIntentId = kf.$route.query.payment_intent;
    kf.orderNumber = kf.$route.query.order_number;

    if (!kf.paymentIntentId && !kf.orderNumber) {
      this.$router.push({ name: 'homepage' });
    }

    kf.$store.dispatch('GetOrder', {
      payment_intent: kf.paymentIntentId,
      order_number: kf.orderNumber
    }).then(function (response) {
      kf.order = response.order;
      kf.$store.dispatch('LoadingOff');

      if (response.order.status === 'Accepted') {
        kf.notifyVue('success', 'The payment successfully went through.');
        kf.$store.dispatch('UpdateCart', []);
        kf.$store.dispatch('UpdateDiscount', null);
      }
    }).catch(function (error) {
      kf.notifyVue('danger', error.message);
      kf.$store.dispatch('LoadingOff');
    });
  },

  methods: {
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  }
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'homepage',
  data: function data() {
    return {
      formError: null,
      email: null,
      name: null,
      subject: null,
      message: null
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    user: function user(state) {
      return state.user;
    },
    location: function location(state) {
      return state.location;
    }
  })),

  methods: {
    sendMessage: function sendMessage() {
      var _this = this;

      var kf = this;
      var locationId = kf.location.id;

      this.$store.dispatch('LoadingOn');
      this.$store.dispatch('SendMessage', {
        location: locationId,
        name: this.name,
        email: this.email,
        subject: this.subject,
        message: this.message
      }).then(function () {
        setTimeout(function () {
          kf.notifyVue('success', 'Your message was successfully sent!');
          kf.$store.dispatch('LoadingOff');
          kf.formError = null;
          kf.name = null;
          kf.email = null;
          kf.subject = null;
          kf.message = null;
        }, 1000);
      }).catch(function (error) {
        _this.$store.dispatch('LoadingOff');
        _this.formError = {
          'name': error.errors.name ? error.errors.name.join(' ') : null,
          'email': error.errors.email ? error.errors.email.join(' ') : null,
          'subject': error.errors.subject ? error.errors.subject.join(' ') : null,
          'message': error.errors.message ? error.errors.message.join(' ') : null
        };
      });
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  },
  mounted: function mounted() {
    var locationId = this.location.id;

    var myLatlng = locationId === 1 ? new window.google.maps.LatLng(51.5181877, -0.0791569) : new window.google.maps.LatLng(51.522148, -0.1130205);
    var mapOptions = {
      zoom: 16,
      center: myLatlng,
      scrollwheel: false,
      styles: [{
        'featureType': 'water',
        'stylers': [{ 'saturation': 43 }, { 'lightness': -11 }, { 'hue': '#0088ff' }]
      }, {
        'featureType': 'road',
        'elementType': 'geometry.fill',
        'stylers': [{ 'hue': '#ff0000' }, { 'saturation': -100 }, { 'lightness': 99 }]
      }, {
        'featureType': 'road',
        'elementType': 'geometry.stroke',
        'stylers': [{ 'color': '#808080' }, { 'lightness': 54 }]
      }, {
        'featureType': 'landscape.man_made',
        'elementType': 'geometry.fill',
        'stylers': [{ 'color': '#ece2d9' }]
      }, {
        'featureType': 'poi.park',
        'elementType': 'geometry.fill',
        'stylers': [{ 'color': '#ccdca1' }]
      }, {
        'featureType': 'road',
        'elementType': 'labels.text.fill',
        'stylers': [{ 'color': '#767676' }]
      }, {
        'featureType': 'road',
        'elementType': 'labels.text.stroke',
        'stylers': [{ 'color': '#ffffff' }]
      }, { 'featureType': 'poi', 'stylers': [{ 'visibility': 'off' }] }, {
        'featureType': 'landscape.natural',
        'elementType': 'geometry.fill',
        'stylers': [{ 'visibility': 'on' }, { 'color': '#b8cb93' }]
      }, { 'featureType': 'poi.park', 'stylers': [{ 'visibility': 'on' }] }, {
        'featureType': 'poi.sports_complex',
        'stylers': [{ 'visibility': 'on' }]
      }, { 'featureType': 'poi.medical', 'stylers': [{ 'visibility': 'on' }] }, {
        'featureType': 'poi.business',
        'stylers': [{ 'visibility': 'simplified' }]
      }]

    };
    var map = new window.google.maps.Map(document.getElementById('map'), mapOptions);

    var contentLiverpool = '<div id="content">' + '<div id="siteNotice">' + '</div>' + '<h3 id="firstHeading" class="firstHeading"><strong>Kungfood</strong></h3>' + '<div id="bodyContent">' + '<p><strong>Liverpool Street</strong></p>' + '<p>126A Middlesex St, Whitechapel, London E1 7HY<br>' + '020 7247 1088<br>' + 'info@kungfood.com</p>' + '</div>' + '</div>';

    var contentClerkenwell = '<div id="content">' + '<div id="siteNotice">' + '</div>' + '<h3 id="firstHeading" class="firstHeading"><strong>Kungfood</strong></h3>' + '<div id="bodyContent">' + '<p><strong>Clerkenwell</strong></p>' + '<p>158 Clerkenwell Rd, London EC1R 5DU<br>' + '020 7713 6338<br>' + 'info@kungfood.com</p>' + '</div>' + '</div>';

    var infowindow = new google.maps.InfoWindow({
      content: locationId === 1 ? contentLiverpool : contentClerkenwell
    });

    var marker = new window.google.maps.Marker({
      position: myLatlng,
      title: 'KungFood ' + locationId === 1 ? 'Liverpool St.' : 'Clerkenwell',
      animation: google.maps.Animation.DROP
    });

    marker.addListener('click', function () {
      infowindow.open(map, marker);
    });

    infowindow.open(map, marker);

    marker.setMap(map);
  }
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

var _env = __webpack_require__(56);

var _env2 = _interopRequireDefault(_env);

var _discountPopup = __webpack_require__(341);

var _discountPopup2 = _interopRequireDefault(_discountPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'homepage',
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    user: function user(state) {
      return state.user;
    },
    location: function location(state) {
      return state.location;
    },
    cart: function cart(state) {
      return state.cart;
    }
  })),
  data: function data() {
    return {
      products: null,
      categories: null,
      selectedCategorySlug: null,
      productsFadeOut: false,
      base_url: _env2.default.base_url
    };
  },
  mounted: function mounted() {
    if (this.location) {
      this.getFeaturedProducts(this.location.id);
    }
  },

  methods: {
    getFeaturedProducts: function getFeaturedProducts(locationId) {
      var _this = this;

      this.$store.dispatch('GetFeaturedProductsData', locationId).then(function (response) {
        _this.products = response.products;
      }).catch(function (e) {
        console.log(e);
      });
    },

    addToCart: function addToCart(title, code, image, productId, price, discount, quantity) {
      var cart = this.cart;
      var hasProductInCart = false;

      cart.forEach(function (row) {
        if (row.id === productId && row.type === 'product') {
          row.quantity = row.quantity + quantity;
          hasProductInCart = true;
        }
      });

      if (!hasProductInCart) {
        this.cart.push({
          type: 'product',
          id: productId,
          title: title,
          code: code,
          image: image,
          price: price,
          discount: discount,
          quantity: quantity
        });
      }

      this.$store.dispatch('UpdateCart', this.cart);
      this.notifyVue('success', quantity + ' of ' + title + ' has been added to your cart.');
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  },
  components: {
    DiscountPopup: _discountPopup2.default
  }
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

var _closedLocationNotice = __webpack_require__(340);

var _closedLocationNotice2 = _interopRequireDefault(_closedLocationNotice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'select-location-popup',
  components: {
    ClosedLocationNotice: _closedLocationNotice2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    cart: function cart(state) {
      return state.cart;
    },
    location: function location(state) {
      return state.location;
    }
  }), (0, _vuex.mapGetters)({
    getLocation: 'getLocation'
  })),
  data: function data() {
    return {
      closedLocationId: null
    };
  },

  methods: {
    selectLocation: function selectLocation(locationId) {
      if (locationId === 2) {
        this.closedLocationId = locationId;
        return;
      }

      var shouldChangeLocation = true;

      if (this.location && this.location.id === locationId) {
        this.$router.push({ name: 'homepage' });
        return;
      }

      if (this.cart.length && !confirm('If you change the restaurant location, your items from the cart will be removed. Are you sure you want to proceed?')) {
        shouldChangeLocation = false;
      }

      if (shouldChangeLocation) {
        this.$store.dispatch('SetLocation', {
          id: locationId,
          setDate: new Date()
        });

        this.$store.dispatch('UpdateCart', []);

        document.getElementById('selectLocationPopup').className = 'fadeout';
        document.getElementById('locationName').textContent = this.getLocation(locationId).name;

        this.$emit('getFeaturedProducts', locationId);
      }

      setTimeout(function () {
        this.$router.push({ name: 'homepage' });
      }.bind(this), 300);
    }
  }
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(167);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'homepage',
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    user: function user(state) {
      return state.user;
    },
    location: function location(state) {
      return state.location;
    },
    cart: function cart(state) {
      return state.cart;
    }
  })),
  data: function data() {
    return {
      lunchBoxes: [],
      selectedBox: []
    };
  },
  created: function created() {
    var _this = this;

    if (this.location) {
      this.$store.dispatch('ListLunchBoxes', this.location.id).then(function (response) {
        _this.lunchBoxes = response.offers;

        for (var i = 0; i < _this.lunchBoxes.length; i++) {
          _this.lunchBoxes[i].quantity = 1;
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  },

  methods: {
    plusQuantity: function plusQuantity(box) {
      this.lunchBoxes = this.lunchBoxes.map(function (lunchBox) {
        if (lunchBox.id === box.id) {
          lunchBox.quantity++;
        }

        return lunchBox;
      });

      this.selectedBox = this.selectedBox.map(function (selBox) {
        if (selBox.box_id === box.id) {
          selBox.quantity++;
        }

        return selBox;
      });
    },
    minusQuantity: function minusQuantity(box) {
      this.lunchBoxes = this.lunchBoxes.map(function (lunchBox) {
        if (lunchBox.id === box.id) {
          lunchBox.quantity = lunchBox.quantity > 1 ? lunchBox.quantity - 1 : 1;
        }

        return lunchBox;
      });

      this.selectedBox = this.selectedBox.map(function (selBox) {
        if (selBox.box_id === box.id) {
          selBox.quantity = selBox.quantity > 1 ? selBox.quantity - 1 : 1;
        }

        return selBox;
      });
    },
    addToBox: function addToBox(box, category, product) {
      var selectedBox = this.selectedBox.filter(function (selBox) {
        return selBox.box_id === box.id;
      });

      var isBoxNew = false;

      if (!selectedBox.length) {
        selectedBox = {
          box_id: box.id,
          box_title: box.title,
          box_code: box.code,
          box_price: box.price,
          box_discount: box.discount,
          note: typeof box.note !== 'undefined' ? box.note : null,
          quantity: box.quantity,
          categories: []
        };

        isBoxNew = true;
      } else {
        selectedBox = selectedBox[0];
      }

      var boxCategory = selectedBox.categories.filter(function (boxCategory) {
        return boxCategory.category_id === category.id;
      });

      var isBoxCategoryNew = false;

      if (!boxCategory.length) {
        boxCategory = {
          category_id: category.id,
          category_title: category.title,
          max_products: category.max_products,
          products: []
        };

        isBoxCategoryNew = true;
      } else {
        boxCategory = boxCategory[0];
      }

      var boxProduct = boxCategory.products.filter(function (boxProduct) {
        return boxProduct.id === product.id;
      });

      if (boxProduct.length) {
        boxCategory.products = boxCategory.products.filter(function (boxProduct) {
          return boxProduct.id !== product.id;
        });
      } else if (boxCategory.products.length === boxCategory.max_products) {
        this.notifyVue('danger', 'You can add maximum ' + boxCategory.max_products + ' products from this category.');
      } else {
        boxCategory.products.push(product);
      }

      if (boxCategory.products.length === 0) {
        selectedBox.categories = selectedBox.categories.filter(function (thisBoxCategory) {
          return thisBoxCategory.category_id !== category.id;
        });
      } else if (!isBoxCategoryNew) {
        selectedBox.categories = selectedBox.categories.map(function (thisBoxCategory) {
          return thisBoxCategory.category_id === category.id ? boxCategory : thisBoxCategory;
        });
      } else {
        selectedBox.categories.push(boxCategory);
      }

      if (selectedBox.categories.length === 0) {
        this.selectedBox = this.selectedBox.filter(function (selBox) {
          return selBox.box_id !== box.id;
        });
      } else if (!isBoxNew) {
        this.selectedBox = this.selectedBox.map(function (selBox) {
          return selBox.box_id === box.id ? selectedBox : selBox;
        });
      } else {
        this.selectedBox.push(selectedBox);
      }
    },

    productIsSelected: function productIsSelected(box, category, product) {
      var selectedBox = this.selectedBox.filter(function (selBox) {
        return selBox.box_id === box.id;
      });

      if (selectedBox.length) {
        selectedBox = selectedBox[0];
        var boxCategory = selectedBox.categories.filter(function (boxCategory) {
          return boxCategory.category_id === category.id;
        });

        if (boxCategory.length) {
          boxCategory = boxCategory[0];
          var boxProduct = boxCategory.products.filter(function (boxProduct) {
            return boxProduct.id === product.id;
          });

          return boxProduct.length;
        }
      }

      return false;
    },
    noteChanged: function noteChanged(box) {
      var selectedBox = this.selectedBox.filter(function (selBox) {
        return selBox.box_id === box.id;
      });

      if (selectedBox.length) {
        selectedBox = selectedBox[0];

        selectedBox.note = box.note;
      }
    },
    addToCart: function addToCart(box) {
      var selectedBox = this.selectedBox.filter(function (selBox) {
        return selBox.box_id === box.id;
      });

      if (selectedBox.length) {
        selectedBox = selectedBox[0];

        if ((0, _keys2.default)(box.categories).length !== selectedBox.categories.length) {
          this.notifyVue('danger', 'Please select from the all available categories.');

          return false;
        }

        this.cart.push({
          type: 'offer',
          offer_id: selectedBox.box_id,
          title: selectedBox.box_title,
          code: selectedBox.box_code,
          image: null,
          price: selectedBox.box_price,
          discount: selectedBox.box_discount,
          note: selectedBox.note,
          quantity: selectedBox.quantity,
          items: selectedBox.categories
        });

        this.selectedBox = this.selectedBox.filter(function (selBox) {
          return selBox.box_id !== box.id;
        });

        this.lunchBoxes = this.lunchBoxes.map(function (lunchBox) {
          if (lunchBox.id === box.id) {
            lunchBox.quantity = 1;
            lunchBox.note = null;
          }

          return lunchBox;
        });

        this.$store.dispatch('UpdateCart', this.cart);
        this.notifyVue('success', 'Lunch Box ' + selectedBox.box_title + ' has been added to your cart.');
      } else {
        this.notifyVue('danger', 'You should select products for this lunch box.');
      }
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  }
};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

var _env = __webpack_require__(56);

var _env2 = _interopRequireDefault(_env);

var _discountPopup = __webpack_require__(341);

var _discountPopup2 = _interopRequireDefault(_discountPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'homepage',
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    user: function user(state) {
      return state.user;
    },
    location: function location(state) {
      return state.location;
    },
    cart: function cart(state) {
      return state.cart;
    }
  })),
  data: function data() {
    return {
      products: null,
      categories: [],
      selectedCategorySlug: null,
      selectedCategoryTitle: null,
      selectedListCategorySlug: null,
      productsFadeOut: false,
      base_url: _env2.default.base_url,
      categoriesVisible: false
    };
  },
  created: function created() {
    var _this = this;

    if (this.location) {
      this.$store.dispatch('ListMenu', this.location.id).then(function (response) {
        _this.products = response.products;
        _this.categories = response.categories;

        if (_this.categories.length > 0) {
          _this.selectedCategorySlug = _this.categories[0].slug;
          _this.selectedCategoryTitle = _this.categories[0].title;
          _this.selectedListCategorySlug = _this.categories[0].slug;
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  },

  methods: {
    changeSelectedCategory: function changeSelectedCategory(categorySlug, categoryTitle) {
      this.productsFadeOut = true;
      this.selectedListCategorySlug = categorySlug;
      document.getElementById('mainPanel').scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      var kf = this;

      kf.categoriesVisible = false;

      setTimeout(function () {
        kf.productsFadeOut = false;
        kf.selectedCategorySlug = categorySlug;
        kf.selectedCategoryTitle = categoryTitle;
      }, 500);
    },
    addToCart: function addToCart(title, code, image, productId, price, discount, quantity) {
      var cart = this.cart;
      var hasProductInCart = false;

      cart.forEach(function (row) {
        if (row.id === productId && row.type === 'product') {
          row.quantity = row.quantity + quantity;
          hasProductInCart = true;
        }
      });

      if (!hasProductInCart) {
        this.cart.push({
          type: 'product',
          id: productId,
          title: title,
          code: code,
          image: image,
          price: price,
          discount: discount,
          quantity: quantity
        });
      }

      this.$store.dispatch('UpdateCart', this.cart);
      this.notifyVue('success', quantity + ' of ' + title + ' has been added to your cart.');
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  },
  components: {
    DiscountPopup: _discountPopup2.default
  }
};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'my-details',
  data: function data() {
    return {
      topError: null,
      formError: null,
      customer: {
        first_name: null,
        last_name: null,
        email: null,
        address: null,
        postcode: null,
        phone: null
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    token: function token(state) {
      return state.token;
    },
    user: function user(state) {
      return state.user;
    }
  })),
  created: function created() {
    this.customer = {
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      email: this.user.email,
      address: this.user.address1,
      postcode: this.user.postcode,
      phone: this.user.phone
    };
  },

  methods: {
    editProfile: function editProfile(e) {
      var _this = this;

      e.preventDefault();

      this.$store.dispatch('LoadingOn');
      this.$store.dispatch('EditCustomer', {
        first_name: this.customer.first_name,
        last_name: this.customer.last_name,
        email: this.customer.email,
        phone: this.customer.phone,
        address: this.customer.address,
        postcode: this.customer.postcode
      }).then(function (response) {
        var kf = _this;
        setTimeout(function () {
          kf.$store.dispatch('LoadingOff');
          kf.formError = null;
          kf.notifyVue('success', 'Your details were successfully saved.');
        }, 1000);
      }).catch(function (error) {
        _this.$store.dispatch('LoadingOff');
        _this.formError = {
          'first_name': error.errors.first_name ? error.errors.first_name.join(' ') : null,
          'last_name': error.errors.last_name ? error.errors.last_name.join(' ') : null,
          'email': error.errors.email ? error.errors.email.join(' ') : null,
          'phone': error.errors.phone ? error.errors.phone.join(' ') : null,
          'postcode': error.errors.postcode ? error.errors.postcode.join(' ') : null,
          'address': error.errors.address ? error.errors.address.join(' ') : null
        };

        if (error.errors.top_error) {
          _this.registration.topError = error.errors.top_error;
        }
      });
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  }
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var kf = void 0;

exports.default = {
  name: 'my-details',
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    cart: function cart(state) {
      return state.cart;
    },
    location: function location(state) {
      return state.location;
    }
  }), (0, _vuex.mapGetters)({
    getLocation: 'getLocation'
  })),
  data: function data() {
    return {
      orders: null,
      boxOrder: null,
      showOrderBox: null
    };
  },
  created: function created() {
    kf = this;

    this.$store.dispatch('GetCustomerOrders').then(function (response) {
      kf.orders = response.orders;
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    paymentSourceLabel: function paymentSourceLabel(order) {
      var source = order ? order.payment_source : null;

      if (!source) {
        return '';
      }

      var wallets = {
        apple_pay: 'Apple Pay',
        google_pay: 'Google Pay',
        link: 'Link'
      };

      var card = source.brand ? source.brand.charAt(0).toUpperCase() + source.brand.slice(1) + (source.last4 ? ' •••• ' + source.last4 : '') : '';
      var wallet = source.wallet ? wallets[source.wallet] || source.wallet : '';

      if (wallet && card) {
        return wallet + ' (' + card + ')';
      }

      return wallet || card || '';
    },
    formatDate: function formatDate(dateStr) {
      var date = new Date(dateStr);
      var curDate = new Date();

      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();
      var hour = date.getHours();
      var minute = date.getMinutes();

      return this.formatToTwoDigits(day) + ' ' + monthNames[monthIndex] + ', ' + (year === curDate.getFullYear() ? this.formatToTwoDigits(hour) + ':' + this.formatToTwoDigits(minute) : year);
    },
    formatToTwoDigits: function formatToTwoDigits(str) {
      return str.toString().length === 1 ? '0' + str : str;
    },
    reorder: function reorder(order) {
      var _this = this;

      if (order.location_id !== kf.location.id) {
        kf.notifyVue('danger', 'This order is not available for this location.');
        return false;
      }

      order.items.forEach(function (product) {
        var hasProductInCart = false;

        if (product.type === 'product') {
          kf.cart.forEach(function (row) {
            if (row.id === product.id) {
              row.quantity = row.quantity + product.quantity;
              hasProductInCart = true;
            }
          });

          if (!hasProductInCart) {
            kf.cart.push({
              type: 'product',
              id: product.id,
              title: product.title,
              code: product.code,
              image: product.image_path,
              price: product.price,
              discount: product.discount,
              quantity: product.quantity
            });
          }
        } else if (product.type === 'offer') {
          var itemsArr = [];

          for (var categoryTitle in product.categorized_items) {
            itemsArr.push({
              category_id: product.categorized_items[categoryTitle][0].category_id,
              category_title: categoryTitle,
              products: product.categorized_items[categoryTitle].map(function (product) {
                return {
                  id: product.product_id,
                  title: product.product_title,
                  code: product.product_code
                };
              })
            });
          }

          _this.cart.push({
            type: 'offer',
            offer_id: product.offer_id,
            title: product.title,
            code: product.code,
            image: null,
            price: product.price,
            discount: product.discount,
            note: product.note,
            quantity: product.quantity,
            items: itemsArr
          });
        }
      });

      kf.$store.dispatch('UpdateCart', this.cart);
      kf.notifyVue('success', 'This order has been added into your cart.');
      kf.$router.push({ name: 'checkout' });
    },
    view: function view(order) {
      this.showOrderBox = true;

      setTimeout(function () {
        kf.boxOrder = order;
      }, 1000);
    },
    closePopup: function closePopup() {
      this.showOrderBox = false;

      setTimeout(function () {
        kf.showOrderBox = null;
      }, 500);
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  }
};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var kf = void 0;

exports.default = {
  name: 'my-payment-sources',
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    location: function location(state) {
      return state.location;
    }
  })),
  data: function data() {
    return {
      sources: []
    };
  },
  created: function created() {
    kf = this;

    kf.$store.dispatch('GetCustomerPaymentSources', kf.location.id).then(function (response) {
      kf.sources = response.sources;
    }).catch(function (error) {
      console.log(error);
    });
  },

  methods: {
    deletePaymentSource: function deletePaymentSource() {
      if (confirm('Are you sure you want to delete this payment card?')) {
        kf.$store.dispatch('DeleteCustomerDefaultPaymentSource', kf.location.id).then(function () {
          kf.sources = [];
        }).catch(function (error) {
          console.log(error);
          kf.notifyVue('error', error);
        });
      }
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  }
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

var _myDetails = __webpack_require__(535);

var _myDetails2 = _interopRequireDefault(_myDetails);

var _myOrders = __webpack_require__(536);

var _myOrders2 = _interopRequireDefault(_myOrders);

var _myPaymentSources = __webpack_require__(537);

var _myPaymentSources2 = _interopRequireDefault(_myPaymentSources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'profile',
  data: function data() {
    return {
      login: {
        email: '',
        password: '',
        topError: null,
        formError: null
      },
      registration: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        password_confirmation: '',
        termsAndCondition: false,
        topError: null,
        formError: null
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    token: function token(state) {
      return state.token;
    },
    user: function user(state) {
      return state.user;
    }
  })),
  methods: {
    signin: function signin(e) {
      var _this = this;

      e.preventDefault();

      this.login.topError = null;
      this.login.formError = null;
      this.registration.topError = null;
      this.registration.formError = null;

      this.$store.dispatch('LoadingOn');
      this.$store.dispatch('Signin', {
        email: this.login.email,
        password: this.login.password
      }).then(function () {
        var kf = _this;
        setTimeout(function () {
          kf.$store.dispatch('LoadingOff');
        }, 1000);
        kf.$router.push({ name: 'profile' });
      }).catch(function (error) {
        _this.$store.dispatch('LoadingOff');
        _this.login.formError = {
          'email': error.errors.email ? error.errors.email.join(' ') : null,
          'password': error.errors.password ? error.errors.password.join(' ') : null
        };

        if (error.errors.top_error) {
          _this.login.topError = error.errors.top_error;
        }
      });
    },
    register: function register(e) {
      var _this2 = this;

      e.preventDefault();

      this.login.topError = null;
      this.login.formError = null;
      this.registration.topError = null;
      this.registration.formError = null;

      if (this.registration.password !== this.registration.password_confirmation) {
        this.registration.formError = {
          'password_confirmation': 'The passwords do not match.'
        };

        this.registration.password_confirmation = '';
      } else if (!this.registration.termsAndCondition) {
        this.registration.topError = 'You should agree with our Terms and Privacy Policy.';
      } else {
        this.$store.dispatch('LoadingOn');
        this.$store.dispatch('Register', {
          first_name: this.registration.firstName,
          last_name: this.registration.lastName,
          email: this.registration.email,
          password: this.registration.password,
          password_confirmation: this.registration.password_confirmation
        }).then(function () {
          var kf = _this2;

          setTimeout(function () {
            kf.$store.dispatch('LoadingOff');
          }, 1000);

          window.location.href = '/profile';
        }).catch(function (error) {
          _this2.$store.dispatch('LoadingOff');
          _this2.registration.formError = {
            'firstName': error.errors.first_name ? error.errors.first_name.join(' ') : null,
            'lastName': error.errors.first_name ? error.errors.last_name.join(' ') : null,
            'email': error.errors.email ? error.errors.email.join(' ') : null,
            'password': error.errors.password ? error.errors.password.join(' ') : null
          };

          if (error.errors.top_error) {
            _this2.registration.topError = error.errors.top_error;
          }
        });
      }
    },
    logout: function logout(e) {
      e.preventDefault();

      if (confirm('Are you sure you want to logout?')) {
        this.$store.dispatch('AuthSignout');
        this.$store.dispatch('LoadingOn');

        var kf = this;

        kf.$router.push({ name: 'homepage' });
        setTimeout(function () {
          kf.$store.dispatch('LoadingOff');
        }, 1000);
      }
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  },
  components: {
    MyDetails: _myDetails2.default,
    MyOrders: _myOrders2.default,
    MyPaymentSources: _myPaymentSources2.default
  }
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'restore-password',
  data: function data() {
    return {
      email: null,
      emailError: null,
      topMessage: null
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    token: function token(state) {
      return state.token;
    },
    user: function user(state) {
      return state.user;
    }
  })),
  created: function created() {
    if (this.token) {
      this.$router.push({ name: 'homepage' });
    }
  },

  methods: {
    restore: function restore(e) {
      var _this = this;

      e.preventDefault();

      this.$store.dispatch('LoadingOn');
      this.$store.dispatch('RestorePassword', {
        email: this.email
      }).then(function () {
        _this.emailError = null;
        _this.topMessage = 'An email has been sent to your inbox. Please follow the process to restore your password.';
        _this.$store.dispatch('LoadingOff');
      }).catch(function (error) {
        console.log(error);
        _this.emailError = error.errors.email ? error.errors.email.join(' ') : null;
        _this.$store.dispatch('LoadingOff');
      });
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  }
};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(21);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'set-password',
  data: function data() {
    return {
      password: null,
      password_confirmation: null,
      passwordError: null,
      topMessage: null,
      topError: null,
      customer: {
        first_name: null,
        last_name: null
      }
    };
  },

  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
    token: function token(state) {
      return state.token;
    },
    user: function user(state) {
      return state.user;
    }
  })),
  props: {
    passwordToken: String
  },
  created: function created() {
    var _this = this;

    if (this.token) {
      this.$router.push({ name: 'homepage' });
    }

    this.$store.dispatch('LoadingOn');
    this.$store.dispatch('GetCustomerByPasswordToken', {
      password_token: this.passwordToken
    }).then(function (response) {
      _this.customer = response;
      _this.$store.dispatch('LoadingOff');
    }).catch(function () {
      _this.$store.dispatch('LoadingOff');
      _this.$router.push({ name: 'homepage' });
      _this.notifyVue('danger', 'This is a non-existent customer.');
    });
  },

  methods: {
    setNewPassword: function setNewPassword(e) {
      var _this2 = this;

      e.preventDefault();

      this.$store.dispatch('LoadingOn');
      this.$store.dispatch('SetNewPassword', {
        password: this.password,
        password_confirmation: this.password_confirmation,
        password_token: this.passwordToken
      }).then(function () {
        _this2.passwordError = null;
        _this2.topError = null;
        _this2.topMessage = 'Your password has been successfully restored. You can now login into your account.';
        _this2.password = null;
        _this2.password_confirmation = null;
        _this2.$store.dispatch('LoadingOff');
      }).catch(function (error) {
        _this2.topMessage = null;
        _this2.topError = error.errors.join(' ');
        _this2.passwordError = error.errors.password ? error.errors.password.join(' ') : null;
        _this2.$store.dispatch('LoadingOff');
      });
    },
    notifyVue: function notifyVue(type, message) {
      this.$notifications.notify({
        message: message,
        icon: '',
        horizontalAlign: 'right',
        verticalAlign: 'bottom',
        type: type
      });
    }
  }
};

/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plate-delimiter.b73ba10.png";

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/top-bg.f58ada6.jpg";

/***/ }),
/* 517 */,
/* 518 */,
/* 519 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(497)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(558),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(562),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(501)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(565),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(555),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(496)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(556),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(500)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(563),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(499)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(560),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(490)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(493)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(551),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(492)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(561),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(487)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(488)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(494)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(495)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(564),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(554),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(566),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "id": "top-header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h1', [_vm._v("Want some Appetizing Food?")]), _vm._v(" "), _c('h2', [_vm._v("Grab yours now!")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-danger btn-fill",
    attrs: {
      "to": "/menu",
      "tag": "button"
    }
  }, [_vm._v("\n              Browse the Menu\n            ")]), _vm._v(" "), _vm._m(0)], 1)])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "featured-menu"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "menu-items"
  }, [(_vm.products) ? _c('div', {
    staticClass: "row row-eq-height"
  }, [_vm._l((_vm.products), function(product) {
    return _c('div', {
      staticClass: "animated zoomIn col-md-3 product-item"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "image"
    }, [(product.gallery.length) ? _c('img', {
      attrs: {
        "src": _vm.base_url + '/' + product.gallery[0].image_path,
        "alt": product.title
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(100),
        "alt": product.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h3', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(product.title))]), _vm._v(" "), _c('p', {
      staticClass: "item-category"
    }, [_c('small', [_vm._v(_vm._s(product.category.title))])]), _vm._v(" "), _c('p', {
      staticClass: "item-description"
    }, [_vm._v("\n                    " + _vm._s(product.description) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "quantity"
    }, [_c('span', {
      staticClass: "q-add",
      on: {
        "click": function($event) {
          product.quantity++
        }
      }
    }, [_vm._v("+")]), _vm._v(" "), _c('span', {
      staticClass: "q-total"
    }, [_vm._v(_vm._s(product.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "q-sub",
      on: {
        "click": function($event) {
          product.quantity > 1 ? product.quantity-- : product.quantity
        }
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row align-items-center"
    }, [_c('div', {
      staticClass: "col-md-6 text-left"
    }, [_c('b-button', {
      staticClass: "btn-danger btn-sm",
      attrs: {
        "disabled": !product.availability
      },
      on: {
        "click": function($event) {
          return _vm.addToCart(product.title, product.code, product.gallery.length ? _vm.base_url + '/' + product.gallery[0].image_path : '', product.id, product.price, product.discount, product.quantity)
        }
      }
    }, [_vm._v(_vm._s(product.availability ? 'Add to cart' : 'Out of stock') + "\n                      ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 text-right"
    }, [(product.discount > 0) ? _c('span', {
      staticClass: "total-price has-discount"
    }, [_c('span', {
      staticClass: "old-price"
    }, [_vm._v("£" + _vm._s(product.price.toFixed(2)))]), _vm._v(" "), _c('span', {
      staticClass: "discount"
    }, [_vm._v("£" + _vm._s(product.discount.toFixed(2)))])]) : _c('span', {
      staticClass: "total-price"
    }, [_vm._v("\n                        £ " + _vm._s(product.price.toFixed(2)) + "\n                      ")])])])])])])
  }), _vm._v(" "), (_vm.products.length == 0) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n              There are no featured products to display. Check Menu page.\n            ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.products) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(3)]) : _vm._e()]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "mid-bg-separator text-center"
  })]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('router-view', {
    on: {
      "getFeaturedProducts": _vm.getFeaturedProducts
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "discount-text-header"
  }, [_vm._v("Get a 10% discount using the code "), _c('strong', [_vm._v("V21CU23")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-bg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(516),
      "alt": "Kungfood background"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-bg-separator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Featured Menu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "loader-1"
  }, [_c('span')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "homepageDiscount"
    }
  }, [_c('div', {
    staticClass: "ticket"
  }, [_c('div', {
    staticClass: "ticket-content"
  }, [_c('h1', [_vm._v("10% OFF")]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "margin": "5px 0 15px"
    }
  }, [_vm._v("For orders above 10£")]), _vm._v(" "), _c('p', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Voucher code")]), _c('br'), _vm._v("\n                V21CU23\n              ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "process-overview"
    }
  }, [_c('div', {
    staticClass: "ornaments"
  }, [_c('img', {
    staticClass: "plater",
    attrs: {
      "src": __webpack_require__(515),
      "alt": "Chopstix plate"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "lamps-left",
    attrs: {
      "src": __webpack_require__(339),
      "align": "Lamps ornaments"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "lamps-right",
    attrs: {
      "src": __webpack_require__(166),
      "align": "Lamps ornaments"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("\n            How it works?\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('div', {
    staticClass: "process"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(514),
      "alt": "Select a Restaurant"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Select a restaurant")]), _vm._v(" "), _c('div', {
    staticClass: "process-step"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('div', {
    staticClass: "process"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(513),
      "alt": "Pick a tasty dish"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Pick a tasty dish")]), _vm._v(" "), _c('div', {
    staticClass: "process-step"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-center"
  }, [_c('div', {
    staticClass: "process"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(512),
      "alt": "Get your delivery"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v("Collect or deliver to your door")]), _vm._v(" "), _c('div', {
    staticClass: "process-step"
  }, [_vm._v("3")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "buildings-separator"
  })])
}]}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("My Orders")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_vm._v("#" + _vm._s(order.order_number))]), _vm._v(" "), _c('td', [_vm._v("£ " + _vm._s(parseFloat(order.sub_total).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.discount_type) + " " + _vm._s(order.discount))]), _vm._v(" "), _c('td', [_vm._v("£" + _vm._s(parseFloat(order.shipping_price).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v("£" + _vm._s(parseFloat(order.admin_fee).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v("£" + _vm._s(parseFloat(order.total).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(order.type))]), _vm._v(" "), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(_vm.getLocation(order.location_id).name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(order.created_at)))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn btn-primary btn-xs",
      on: {
        "click": function($event) {
          return _vm.view(order)
        }
      }
    }, [_vm._v("View Details")]), _vm._v(" "), _c('div', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.reorder(order)
        }
      }
    }, [_vm._v("Reorder")])])])
  }), _vm._v(" "), (!_vm.orders) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("You have no orders")])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    class: ['order-box', (_vm.showOrderBox !== null ? (_vm.showOrderBox ? 'animated fadeIn' : 'animated fadeOut') : 'not-displayed')]
  }, [_c('div', {
    staticClass: "order-content"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("×")]), _vm._v(" "), (!_vm.boxOrder) ? _c('div', {
    staticClass: "text-center pt-2 pb-2"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.boxOrder) ? _c('div', {
    staticClass: "order-details"
  }, [_c('h3', [_vm._v("Order #" + _vm._s(_vm.boxOrder.order_number))]), _vm._v(" "), _c('h5', [_vm._v("Order placed at " + _vm._s(_vm.formatDate(_vm.boxOrder.created_at)))]), _vm._v(" "), _vm._l((_vm.boxOrder.items), function(product) {
    return _c('div', [(product.type == 'product') ? _c('div', {
      staticClass: "order-box-product"
    }, [_c('div', {
      staticClass: "product_title pull-left"
    }, [_vm._v("\n              " + _vm._s(product.quantity) + " x\n              " + _vm._s(product.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "product_price pull-right"
    }, [(product.discount > 0) ? _c('span', [_c('strike', [_vm._v("£ " + _vm._s(parseFloat(product.price).toFixed(2)))]), _vm._v("\n              £ " + _vm._s(parseFloat(product.discount).toFixed(2)) + "\n            ")], 1) : _c('span', [_vm._v("£ " + _vm._s(parseFloat(product.price).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e(), _vm._v(" "), (product.type == 'offer') ? _c('div', {
      staticClass: "order-box-product"
    }, [_c('div', {
      staticClass: "product_title pull-left"
    }, [_vm._v("\n              " + _vm._s(product.quantity) + " x\n              " + _vm._s(product.title) + "\n              "), _c('div', {
      staticClass: "offer-items"
    }, _vm._l((product.categorized_items), function(items, categoryTitle) {
      return _c('div', [_c('div', {
        staticClass: "offer-category"
      }, [_vm._v(_vm._s(categoryTitle))]), _vm._v(" "), _vm._l((items), function(item) {
        return _c('div', {
          staticClass: "offer-item"
        }, [_vm._v("\n                    " + _vm._s(item.product_title) + "\n                  ")])
      })], 2)
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "product_price pull-right"
    }, [(product.discount > 0) ? _c('span', [_c('strike', [_vm._v("£ " + _vm._s(parseFloat(product.price).toFixed(2)))]), _vm._v("\n              £ " + _vm._s(parseFloat(product.discount).toFixed(2)) + "\n            ")], 1) : _c('span', [_vm._v("£ " + _vm._s(parseFloat(product.price).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "box-order-details"
  }, [_c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-capitalize"
  }, [_vm._v(_vm._s(_vm.boxOrder.type))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("£" + _vm._s(parseFloat(_vm.boxOrder.sub_total).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.boxOrder.discount) ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Discount")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.boxOrder.discount) + " " + _vm._s(_vm.boxOrder.discount_type))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.boxOrder.type == 'delivery') ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("£" + _vm._s(parseFloat(_vm.boxOrder.shipping_price).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.boxOrder.type == 'delivery' && _vm.boxOrder.delivery_address) ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Delivered to")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v(_vm._s(_vm.boxOrder.delivery_address))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.boxOrder.type == 'delivery' && _vm.boxOrder.delivery_postcode) ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.boxOrder.delivery_postcode))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.paymentSourceLabel(_vm.boxOrder)) ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Paid with")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v(_vm._s(_vm.paymentSourceLabel(_vm.boxOrder)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("£" + _vm._s(parseFloat(_vm.boxOrder.total).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-danger mb-3",
    on: {
      "click": function($event) {
        return _vm.reorder(_vm.boxOrder)
      }
    }
  }, [_vm._v("Reorder")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Order No.")]), _vm._v(" "), _c('th', [_vm._v("Subtotal, £")]), _vm._v(" "), _c('th', [_vm._v("Discount, %")]), _vm._v(" "), _c('th', [_vm._v("Shipping, £")]), _vm._v(" "), _c('th', [_vm._v("Admin Fee, £")]), _vm._v(" "), _c('th', [_vm._v("Total, £")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Ordered at")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-1"
  }, [_c('span')])
}]}

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "selectLocationPopup"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), (!_vm.closedLocationId) ? [_c('h1', [_vm._v("Choose your nearest location")]), _vm._v(" "), _c('div', {
    staticClass: "locations"
  }, [_c('div', {
    staticClass: "location",
    on: {
      "click": function($event) {
        return _vm.selectLocation(1)
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "d": "M176.381,71.938c17.639,0,32.173-14.3,32.173-31.94V7.821h94.892v32.177c0,17.641,14.648,31.94,32.287,31.94"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#808080"
    },
    attrs: {
      "x": "184.132",
      "y": "71.938",
      "width": "143.735",
      "height": "79.855"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "216.072",
      "y": "103.881",
      "width": "79.855",
      "height": "47.91"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FBB03B"
    },
    attrs: {
      "x": "152.244",
      "y": "151.786",
      "width": "207.511",
      "height": "23.955"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "d": "M463.609,288.037c-61.74,0-111.79-48.721-111.79-111.288h-191.64c0,62.566-50.05,111.539-111.79,111.539"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FBB03B"
    },
    attrs: {
      "x": "104.287",
      "y": "264.363",
      "width": "303.436",
      "height": "22.937"
    }
  }), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "447.64",
      "y": "319.473",
      "width": "31.94",
      "height": "63.88"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "32.42",
      "y": "319.473",
      "width": "31.94",
      "height": "63.88"
    }
  })]), _c('rect', {
    staticStyle: {
      "fill": "#808080"
    },
    attrs: {
      "x": "128.24",
      "y": "287.533",
      "width": "255.52",
      "height": "167.688"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "168.168",
      "y": "367.378",
      "width": "175.675",
      "height": "87.833"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#4D4D4D"
    },
    attrs: {
      "x": "96.3",
      "y": "287.533",
      "width": "31.94",
      "height": "167.688"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "96.3",
      "y": "407.306",
      "width": "31.94",
      "height": "47.91"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#4D4D4D"
    },
    attrs: {
      "x": "383.76",
      "y": "287.533",
      "width": "31.94",
      "height": "167.688"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "383.76",
      "y": "407.306",
      "width": "31.94",
      "height": "47.91"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FBB03B"
    },
    attrs: {
      "x": "80.325",
      "y": "455.221",
      "width": "351.34",
      "height": "24.455"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FF1D25"
    },
    attrs: {
      "x": "49.01",
      "y": "479.174",
      "width": "413.98",
      "height": "23.956"
    }
  }), _c('rect', {
    attrs: {
      "y": "495.837",
      "width": "512",
      "height": "15.642"
    }
  }), _c('rect', {
    attrs: {
      "x": "49.01",
      "y": "471.853",
      "width": "413.98",
      "height": "15.642"
    }
  }), _c('polygon', {
    attrs: {
      "points": "352.456,439.528 336.815,439.528 336.815,374.876 175.185,374.876 175.185,439.528 159.544,439.528 159.544,359.234 352.456,359.234 "
    }
  }), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "159.544",
      "y": "336.293",
      "width": "192.912",
      "height": "15.642"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "208.554",
      "y": "311.267",
      "width": "94.892",
      "height": "15.642"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "224.196",
      "y": "407.202",
      "width": "15.642",
      "height": "15.642"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "#FFFFFF"
    },
    attrs: {
      "x": "272.163",
      "y": "407.202",
      "width": "15.642",
      "height": "15.642"
    }
  })]), _c('polygon', {
    attrs: {
      "points": "303.446,136.081 287.805,136.081 287.805,112.098 224.196,112.098 224.196,136.081 208.554,136.081 208.554,96.456 303.446,96.456 "
    }
  }), _c('path', {
    attrs: {
      "d": "M368.098,32.847v15.642h14.391c-3.395,9.011-12.413,15.642-22.685,15.642h-24.032v-0.014c-13.556,0-23.984-10.82-23.984-24.119V0.521H200.212v39.476c0,13.299-10.428,24.119-23.984,24.119v0.014h-24.035c-10.272,0-19.291-6.631-22.686-15.642h14.395V32.847h-31.283v7.821c0,21.196,18.021,39.104,39.574,39.104h25.078v63.609h-25.026v15.642h207.511v-15.642h-25.026V79.772h25.074c21.553,0,39.577-17.907,39.577-39.104v-7.821H368.098z M215.853,39.998V16.163h80.293v23.835c0,9.07,3.041,17.435,8.148,24.133h-16.49V23.462h-15.642V64.13h-9.385V23.462h-15.642V64.13h-7.299V23.462h-15.642V64.13h-16.49C212.813,57.433,215.853,49.068,215.853,39.998z M319.088,143.381h-56.31V120.44h-15.642v22.941h-54.224V79.772h126.175V143.381z"
    }
  }), _c('path', {
    attrs: {
      "d": "M463.511,199.69h-7.821v31.283h15.642v-14.625c14.477,3.232,24.332,15.447,24.332,31.395c0,17.634-14.151,31.999-31.631,32.23v-0.018c-28.155,0-54.161-10.67-73.694-30.044c-5.745-5.698-10.74-11.973-14.942-18.699v-0.239h-0.148c-10.057-16.196-15.493-35.003-15.493-54.745v-7.821H152.244v7.821c0,19.734-5.429,38.54-15.472,54.745h-0.17v0.274c-4.203,6.735-9.2,13.02-14.946,18.728c-18.527,18.406-42.862,28.964-69.337,30.008h-3.932c-17.674,0-32.054-14.463-32.054-32.24c0-15.364,10.201-27.9,24.334-31.316v14.547H56.31V199.69h-7.821c-26.801,0-47.796,21.117-47.796,47.966c0,26.261,21.169,47.728,47.275,47.957v0.103c1.542,0,40.668-0.093,40.668-0.093v151.202h-8.342v15.642h351.413v-15.642h-8.342V295.624h40.245c26.301,0,47.696-21.566,47.696-47.968C511.306,220.361,490.759,199.69,463.511,199.69z M132.737,261.073c1.323-1.314,2.611-2.656,3.866-4.022v14.59h15.642v-35.922c8.992-15.644,14.346-33.225,15.509-51.67h0.132v87.593h15.642v-87.593h16.684v87.593h15.642v-87.593h15.642v87.593h15.642v-87.593h17.727v87.593h15.642v-87.593h15.642v87.593h15.642v-87.593h16.684v87.593h15.642v-87.593h0.129c1.163,18.441,6.519,36.012,15.512,51.642v35.951h15.642v-14.643c1.256,1.365,2.544,2.705,3.869,4.019c7.541,7.48,15.927,13.826,24.958,18.967H107.934C116.904,274.85,125.238,268.524,132.737,261.073z M104.277,415.544h16.684v31.283h-16.684V415.544z M391.039,446.827v-31.283h16.684v31.283H391.039z M407.723,399.902h-16.684v-96.978h-15.642v143.902H262.778v-63.609h-15.642v63.609H136.603V302.925h-15.642v96.978h-16.684V295.625h303.446V399.902z"
    }
  }), _c('path', {
    attrs: {
      "d": "M471.332,302.925H455.69v8.728h-15.873v79.522h15.873v16.027h15.642v-16.027h16.067v-79.522h-16.067V302.925z M471.757,375.533h-16.298v-48.239h16.298V375.533z"
    }
  }), _c('path', {
    attrs: {
      "d": "M56.31,302.925H40.668v8.728H24.597v79.522h16.071v16.027H56.31v-16.027h15.869v-79.522H56.31V302.925z M56.537,375.533H40.238v-48.239h16.298V375.533z"
    }
  }), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g')]), _vm._v(" "), _c('p', [_vm._v("Liverpool St.")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("EC2")])]), _vm._v(" "), _c('div', {
    staticClass: "location",
    on: {
      "click": function($event) {
        return _vm.selectLocation(2)
      }
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#B4826E"
    },
    attrs: {
      "d": "M316.492,308.418H195.507V172.52h120.986V308.418z M155.553,366.66v135.898h200.893V366.66H155.553z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#A06E5F"
    },
    attrs: {
      "d": "M297.359,312.786v189.772h-82.72V312.786h19.133V172.52h44.455v140.267L297.359,312.786L297.359,312.786z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#E6C8A0"
    },
    attrs: {
      "d": "M135.464,392.869v-31.063c0-2.681,2.141-4.854,4.783-4.854h231.505c2.642,0,4.783,2.173,4.783,4.854v31.063c0,2.681-2.141,4.854-4.783,4.854H140.246C137.605,397.723,135.464,395.55,135.464,392.869z M400.451,444.316H111.547c-2.642,0-4.783,2.173-4.783,4.854v21.355c0,2.681,2.141,4.854,4.783,4.854h288.903c2.642,0,4.783-2.173,4.783-4.854V449.17C405.234,446.489,403.092,444.316,400.451,444.316z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#C83741"
    },
    attrs: {
      "d": "M416.187,327.832L416.187,327.832c0,16.083-12.849,29.121-28.699,29.121H263.125h-14.252H124.511c-15.85,0-28.699-13.038-28.699-29.121l0,0l42.008-17.074c19.307-7.847,35.818-21.447,47.355-39.007l0,0c0.887-1.35,2.381-2.161,3.98-2.161h59.719h14.252h59.719c1.599,0,3.093,0.811,3.98,2.161l0,0c11.537,17.56,28.048,31.16,47.355,39.007L416.187,327.832z M376.536,170.659l-32.1-15.793c-28.283-13.915-52.879-34.487-71.738-60.003l0,0h-33.395l0,0c-18.859,25.515-43.455,46.088-71.738,60.003l-32.1,15.793v26.128h241.071V170.659z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#D2B48C"
    },
    attrs: {
      "d": "M443.5,478.291v21.355c0,2.681-2.141,4.854-4.783,4.854H73.282c-2.642,0-4.783-2.173-4.783-4.854v-21.355c0-2.681,2.141-4.854,4.783-4.854h306.739c0.605-0.813,0.978-1.814,0.978-2.912V449.17c0-2.681-2.141-4.854-4.783-4.854h24.235c2.642,0,4.783,2.173,4.783,4.854v21.355c0,1.098-0.373,2.099-0.978,2.912h34.46C441.359,473.438,443.5,475.61,443.5,478.291z M347.518,397.723h24.235c2.642,0,4.783-2.173,4.783-4.854v-31.063c0-2.681-2.141-4.854-4.783-4.854h-24.235c2.642,0,4.783,2.173,4.783,4.854v31.063C352.3,395.55,350.159,397.723,347.518,397.723z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#C5AB8C"
    },
    attrs: {
      "d": "M443.5,478.291v21.355c0,2.681-2.141,4.854-4.783,4.854h-24.235c2.642,0,4.783-2.173,4.783-4.854v-21.355c0-2.681-2.142-4.854-4.783-4.854h24.235C441.359,473.438,443.5,475.61,443.5,478.291z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#AA4141"
    },
    attrs: {
      "d": "M376.536,196.787h-90.119c-14.885-20.306-23.72-45.608-23.72-73.045c0-9.953,1.171-19.623,3.362-28.878h6.639c18.859,25.515,43.455,46.088,71.738,60.003l32.1,15.793V196.787z M374.18,310.758c-19.307-7.847-35.818-21.447-47.355-39.007c-0.887-1.35-2.381-2.161-3.98-2.161h-19.969c-0.311,3.598-0.479,7.239-0.479,10.92c0,28.99,9.863,55.596,26.304,76.443h58.788c15.85,0,28.699-13.038,28.699-29.121L374.18,310.758z"
    }
  }), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#963737"
    },
    attrs: {
      "d": "M440.221,325.315l-6.617,12.309c-10.058,18.711-29.385,30.353-50.389,30.353h-9.932H138.715h-9.932c-21.004,0-40.331-11.642-50.389-30.353l-6.617-12.309c-2.073-3.856,1.566-8.3,5.682-6.939l0,0c21.569,7.137,44.114,10.773,66.801,10.773h223.478c22.687,0,45.232-3.636,66.801-10.773l0,0C438.656,317.014,442.294,321.458,440.221,325.315z M107.986,180.995c10.058,18.711,29.385,30.353,50.39,30.353h9.932h175.383h9.932c21.004,0,40.331-11.642,50.39-30.353l6.617-12.309c2.073-3.856-1.566-8.301-5.682-6.939l0,0c-21.569,7.137-44.114,10.773-66.801,10.773H173.854c-22.687,0-45.232-3.636-66.801-10.773l0,0c-4.116-1.362-7.755,3.082-5.682,6.939L107.986,180.995z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#963737"
    },
    attrs: {
      "d": "M272.55,70.986c4.909,2.313,8.321,7.346,8.321,13.2l0,0c0,8.041-6.424,14.561-14.349,14.561h-21.046c-7.925,0-14.349-6.519-14.349-14.561l0,0c0-5.854,3.412-10.887,8.321-13.2c-5.105-4.622-8.321-11.345-8.321-18.833l0,0c0-13.939,11.136-25.238,24.872-25.238c13.737,0,24.872,11.3,24.872,25.238l0,0C280.872,59.64,277.656,66.364,272.55,70.986z"
    }
  })]), _c('path', {
    attrs: {
      "d": "M438.691,465.938h-25.958V449.17c0-6.812-5.51-12.354-12.283-12.354h-36.505v-31.594h7.807c6.773,0,12.283-5.542,12.283-12.354v-17.407c23.463-0.299,44.933-13.373,56.176-34.287l6.617-12.311c2.419-4.501,1.86-9.938-1.424-13.848c-3.249-3.869-8.441-5.345-13.222-3.761c-7.306,2.417-14.718,4.408-22.205,5.986c-0.16-0.078-0.319-0.159-0.486-0.227l-32.488-13.205c-17.978-7.307-33.162-19.816-43.911-36.176c-2.066-3.147-5.411-5.126-9.1-5.472v-43.314h29.63c23.783,0,45.623-13.144,56.995-34.302l6.618-12.31c2.419-4.502,1.86-9.938-1.424-13.848c-3.249-3.868-8.44-5.343-13.221-3.761c-8.991,2.975-18.139,5.314-27.394,7.016l-27.452-13.506c-24.452-12.03-46.368-29.551-63.666-50.837c2.695-3.668,4.292-8.206,4.292-13.113c0-5.267-1.863-10.271-5.139-14.2c3.246-5.043,5.139-11.037,5.139-17.468v-0.731c0-15.268-10.628-28.093-24.872-31.486V7.5c0-4.142-3.357-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5v12.801c-14.244,3.393-24.873,16.218-24.873,31.486v0.731c0,6.431,1.893,12.425,5.14,17.469c-3.274,3.937-5.14,8.961-5.14,14.198c0,4.906,1.596,9.441,4.289,13.109c-17.294,21.283-39.217,38.815-63.663,50.842l-26.683,13.127c-0.242,0.119-0.474,0.251-0.698,0.392c-9.279-1.703-18.451-4.046-27.464-7.029c-4.784-1.582-9.973-0.107-13.222,3.762c-3.284,3.911-3.843,9.346-1.422,13.848l6.617,12.309c11.374,21.158,33.213,34.302,56.996,34.302h29.63v43.314c-3.688,0.346-7.032,2.325-9.1,5.471c-10.75,16.361-25.934,28.871-43.911,36.177l-33.022,13.421c-7.471-1.576-14.867-3.563-22.158-5.976c-4.784-1.582-9.973-0.106-13.222,3.762c-3.284,3.911-3.843,9.347-1.422,13.848l6.617,12.31c11.242,20.914,32.712,33.989,56.176,34.287v17.407c0,6.812,5.51,12.354,12.283,12.354h7.806v31.594h-36.505c-6.773,0-12.283,5.542-12.283,12.354v16.768H73.307c-6.787,0-12.308,5.542-12.308,12.354v21.355c0,6.811,5.521,12.353,12.308,12.353h365.385c6.786,0,12.308-5.542,12.308-12.354v-21.355C451,471.479,445.479,465.938,438.691,465.938z M348.945,436.816h-44.086v-31.594h44.086V436.816L348.945,436.816z M289.859,405.223v31.594h-67.72v-31.594H289.859z M308.992,262.09h-23.266v-43.242h23.266V262.09z M270.727,218.848v43.242h-29.455v-43.242L270.727,218.848L270.727,218.848z M238.626,84.186c0-1.337,0.379-2.622,1.049-3.729c4.796,2.813,10.373,4.435,16.324,4.435s11.528-1.621,16.324-4.435c0.669,1.104,1.048,2.386,1.048,3.73c0,3.893-3.072,7.061-6.849,7.061h-21.046C241.699,91.246,238.626,88.079,238.626,84.186z M238.626,51.787c0-9.579,7.793-17.373,17.373-17.373c9.58,0,17.372,7.793,17.372,17.373v0.731c0,9.579-7.793,17.373-17.372,17.373c-9.579,0-17.373-7.793-17.373-17.373V51.787z M170.874,161.595c26.798-13.184,50.777-32.497,69.564-55.948c1.618,0.387,3.304,0.598,5.037,0.598h21.046c1.733,0,3.417-0.211,5.035-0.598c18.792,23.455,42.761,42.76,69.566,55.947l6.499,3.197c-3.153,0.146-6.312,0.227-9.477,0.227H173.854c-3.165,0-6.324-0.082-9.477-0.227L170.874,161.595z M114.592,177.443l-3.535-6.577c20.401,6.076,41.494,9.153,62.796,9.153h164.292c21.303,0,42.394-3.077,62.796-9.153l-3.536,6.577c-8.754,16.287-25.531,26.404-43.783,26.404H158.376C140.124,203.848,123.347,193.73,114.592,177.443z M226.271,218.848v43.242h-23.266v-43.242L226.271,218.848L226.271,218.848z M140.643,317.707c20.357-8.274,37.612-22.301,49.986-40.617h130.739c12.374,18.316,29.629,32.343,49.986,40.617l8.777,3.567c-4.12,0.249-8.252,0.375-12.393,0.375H144.26c-4.141,0-8.274-0.126-12.394-0.375L140.643,317.707z M84.999,334.073l-3.535-6.578c20.4,6.076,41.493,9.153,62.796,9.153h223.478c21.303,0,42.396-3.077,62.796-9.153L427,334.073c-8.756,16.287-25.532,26.404-43.784,26.404H128.783C110.531,360.477,93.754,350.359,84.999,334.073z M142.964,375.477h226.072v14.746H142.964V375.477z M163.053,405.223h44.086v31.594h-44.086V405.223z M436,497h-360v-16.063h232.403c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H114.264v-14.121h283.469v14.121h-58.562c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5H436V497z"
    }
  }), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g')]), _vm._v(" "), _c('p', [_vm._v("Clerkenwell")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("EC1")])])])] : _c('closed-location-notice', [_c('div', {
    staticClass: "back-link",
    on: {
      "click": function($event) {
        _vm.closedLocationId = null
      }
    }
  }, [_vm._v("‹ Back to locations")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ornaments"
  }, [_c('img', {
    staticClass: "lamps-left",
    attrs: {
      "src": __webpack_require__(339),
      "align": "Lamps ornaments"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "lamps-right",
    attrs: {
      "src": __webpack_require__(166),
      "align": "Lamps ornaments"
    }
  })])
}]}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-11 col-sm-4 alert open",
    class: [_vm.verticalAlign, _vm.horizontalAlign, _vm.alertType],
    style: (_vm.customPosition),
    attrs: {
      "data-notify": "container",
      "role": "alert",
      "data-notify-position": "top-center"
    }
  }, [_c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "5px",
      "z-index": "1033"
    },
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "data-notify": "dismiss"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-xs-1 alert-icon",
    class: _vm.icon
  }), _vm._v(" "), _c('div', {
    class: _vm.hasIcon ? 'col-xs-8' : 'col-xs-12'
  }, [_vm._t("message", function() {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.message)
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.showCart !== null ? (_vm.showCart ? 'animated bounceInRight' : 'animated bounceOutRight') : '',
    attrs: {
      "id": "cartPopup"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closeCartPopup
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("Your Cart")]), _vm._v(" "), _c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "products"
  }, _vm._l((_vm.cart), function(row, index) {
    return (_vm.showFullList ? true : (index < 4)) ? _c('div', {
      staticClass: "product"
    }, [_c('div', {
      staticClass: "image"
    }, [(row.image && row.image !== '') ? _c('img', {
      attrs: {
        "src": row.image,
        "alt": row.title
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(100),
        "alt": row.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('div', {
      staticClass: "quantity"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_vm._v("x " + _vm._s(row.quantity))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_vm._v("£" + _vm._s((row.discount > 0 ? row.discount : row.price).toFixed(2)))])])]), _vm._v(" "), _c('div', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deleteProductFromCart(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.showFullList && _vm.cart.length > 4) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.showFullList = true
      }
    }
  }, [_vm._v("View " + _vm._s(_vm.cart.length - 4) + " product" + _vm._s(_vm.cart.length > 5 ? 's' : '') + " more")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "totals"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('strong', [_vm._v("£" + _vm._s(_vm.getCartTotal.toFixed(2)))])])]), _vm._v(" "), _c('div', {
    staticClass: "btns text-center"
  }, [_c('div', {
    on: {
      "click": _vm.goToCheckout
    }
  }, [_c('b-button', {
    staticClass: "btn-default btn-fill full-width"
  }, [_vm._v("Checkout")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ornaments"
  }, [_c('img', {
    staticClass: "lamps-right",
    attrs: {
      "src": __webpack_require__(166),
      "align": "Lamps ornaments"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('strong', [_vm._v("Subtotal")])])
}]}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "restore-password"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Set New Password")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("\n            Welcome " + _vm._s(_vm.customer.first_name) + " " + _vm._s(_vm.customer.last_name) + "! You can now restore your password.\n          ")]), _vm._v(" "), (_vm.topMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v(_vm._s(_vm.topMessage))])]) : _vm._e(), _vm._v(" "), (_vm.topError) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.topError))])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    class: [_vm.password ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.passwordError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.password_confirmation ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password Confirmation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password_confirmation),
      expression: "password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password Confirmation"
    },
    domProps: {
      "value": (_vm.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password_confirmation = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.setNewPassword($event)
      }
    }
  }, [_vm._v("Restore")])], 1)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profile"
    }
  }, [(!_vm.token) ? _c('div', {
    staticClass: "half-side"
  }) : _vm._e(), _vm._v(" "), (!_vm.token) ? [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-offset-1"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Sign in")]), _vm._v(" "), (_vm.login.topError) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.login.topError))])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    class: [_vm.login.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.email),
      expression: "login.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.login.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.login.formError && typeof _vm.login.formError.email !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.login.formError.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.login.password ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.login.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.login.formError && typeof _vm.login.formError.password !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.login.formError.password))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.signin($event)
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-link pull-right",
    attrs: {
      "to": "/restore-password",
      "tag": "button"
    }
  }, [_vm._v("\n                  Forgot Password?\n                ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "register"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Register")]), _vm._v(" "), (_vm.registration.topError) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.registration.topError))])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.registration.firstName ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.firstName),
      expression: "registration.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.registration.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.firstName !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.firstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.registration.lastName ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.lastName),
      expression: "registration.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.registration.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.lastName !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.lastName))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    class: [_vm.registration.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.email),
      expression: "registration.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.registration.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.email !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.registration.password ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.password),
      expression: "registration.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.registration.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.password !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.password))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.registration.password_confirmation ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registration.password_confirmation),
      expression: "registration.password_confirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.registration.password_confirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registration, "password_confirmation", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.registration.formError && typeof _vm.registration.formError.password_confirmation !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.registration.formError.password_confirmation))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group not-hide-label"
  }, [_c('b-form-checkbox', {
    class: [_vm.registration.termsAndCondition ? 'is-checked' : ''],
    attrs: {
      "id": "termsAndConditions",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.registration.termsAndCondition),
      callback: function($$v) {
        _vm.$set(_vm.registration, "termsAndCondition", $$v)
      },
      expression: "registration.termsAndCondition"
    }
  }, [_vm._v("\n                  I agree with "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Terms")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Privacy")]), _vm._v("\n                  of Kungfood.co.uk\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.register($event)
      }
    }
  }, [_vm._v("Register")])], 1)])])])])])] : _vm._e(), _vm._v(" "), (_vm.token) ? [_c('div', {
    staticClass: "my-profile"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('h2', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _vm._v(" "), _c('h5', [_vm._v("Kungfood member since " + _vm._s(_vm.user.created_at))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('b-btn', {
    staticClass: "logout-btn",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "My Details",
      "active": ""
    }
  }, [_c('br'), _vm._v(" "), _c('MyDetails')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "My Orders"
    }
  }, [_c('br'), _vm._v(" "), _c('MyOrders')], 1), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "My Payment Sources"
    }
  }, [_c('br'), _vm._v(" "), _c('MyPaymentSources')], 1)], 1)], 1)])])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.showPopup ? 'show' : '',
    attrs: {
      "id": "discountPopup"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "ticket"
  }, [_c('div', {
    staticClass: "ticket-border-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "ticket-content"
  }, [_c('p', {
    staticClass: "top"
  }, [_vm._v("Take an extra discount")]), _vm._v(" "), _c('h1', [_vm._v("10% OFF")]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "margin": "5px 0 15px"
    }
  }, [_vm._v("For orders above 10£")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('b-button', {
    staticClass: "btn-danger btn-fill",
    on: {
      "click": _vm.setDiscount
    }
  }, [_vm._v("Use Now")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ticket-border-right"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Voucher code")]), _c('br'), _vm._v("\n          V21CU23\n        ")])
}]}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown",
    class: {
      open: _vm.isOpen
    },
    on: {
      "click": _vm.toggleDropDown
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle btn-rotate",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_vm._t("title", function() {
    return [_c('i', {
      class: _vm.icon
    }), _vm._v(" "), _c('p', {
      staticClass: "notification"
    }, [_vm._v(_vm._s(_vm.title) + "\n        "), _c('b', {
      staticClass: "caret"
    })])]
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "checkout"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [(_vm.order && _vm.order.status === 'Accepted') ? _c('div', [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Order went through successfully!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            You should receive a confirmation email very shortly"), (_vm.user && _vm.user.email) ? [_vm._v(" on "), _c('strong', [_vm._v(_vm._s(_vm.user.email))])] : _vm._e(), _vm._v(".\n            Enjoy your food and do not forget to come back to let us know how it was!\n          ")], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Order Number:")]), _vm._v(" #" + _vm._s(_vm.order.order_number))]), _vm._v(" "), (_vm.order.type === 'delivery' && _vm.order.delivery_address) ? _c('p', [_c('strong', [_vm._v("Delivering to:")]), _vm._v(" " + _vm._s(_vm.order.delivery_address)), (_vm.order.delivery_postcode) ? [_vm._v(", " + _vm._s(_vm.order.delivery_postcode))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger btn-fill",
    attrs: {
      "to": "/",
      "tag": "button"
    }
  }, [_vm._v("\n            Check more products\n          ")])], 1) : (_vm.order) ? _c('div', [_c('h2', {
    staticClass: "section-title text-red"
  }, [_vm._v("Order was not successful!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n            Unfortunately there has been an error while trying to process your payment."), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.order.status_message))])]), _vm._v(" "), _c('p', [_vm._v("We advise you to go back to checkout and try again.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-danger btn-fill",
    attrs: {
      "to": "/checkout",
      "tag": "button"
    }
  }, [_vm._v("\n            Go back to checkout\n          ")])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('u', [_vm._v("Error message:")])])
}]}

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "checkout"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ['checkout-col col-md-8', _vm.sideCartVisible ? 'not-visible' : '']
  }, [_c('div', {
    staticClass: "checkout-form"
  }, [_c('div', {
    staticClass: "mobile see-cart btn btn-sm btn-danger",
    on: {
      "click": function($event) {
        _vm.sideCartVisible = !_vm.sideCartVisible
      }
    }
  }, [_vm._v("\n              Check Cart "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Order Type")]), _vm._v(" "), _c('b-form-radio-group', {
    staticClass: "radio-boxes",
    attrs: {
      "id": "radios2"
    },
    model: {
      value: (_vm.orderType),
      callback: function($$v) {
        _vm.orderType = $$v
      },
      expression: "orderType"
    }
  }, [_c('b-form-radio', {
    class: [_vm.orderType === 'collection' ? 'is-checked' : ''],
    attrs: {
      "value": "collection"
    }
  }, [_vm._v("\n                  Collection\n                  "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be available for collection in 20 minutes")])]), _vm._v(" "), (_vm.location.id === 1 && _vm.websiteAvailability.canDoDelivery && _vm.currentHour + '' + _vm.currentMinute >= '1600') ? _c('b-form-radio', {
    class: [_vm.orderType === 'delivery' ? 'is-checked' : ''],
    attrs: {
      "value": "delivery"
    }
  }, [_vm._v("\n                  Delivery "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("(min. £ " + _vm._s(_vm.minimumForDelivery.toFixed(2)) + ")")]), _vm._v(" "), (_vm.currentHour + '' + _vm.currentMinute >= '1900' && _vm.currentHour + '' + _vm.currentMinute <= '2200') ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be delivered between in 50 minutes - 1h")]) : _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be delivered within 45min")])]) : _vm._e(), _vm._v(" "), (_vm.location.id === 2 && _vm.websiteAvailability.canDoDelivery && _vm.currentHour + '' + _vm.currentMinute >= '1600') ? _c('b-form-radio', {
    class: [_vm.orderType === 'delivery' ? 'is-checked' : ''],
    attrs: {
      "value": "delivery"
    }
  }, [_vm._v("\n                  Delivery "), _c('span', {
    staticClass: "subtitle"
  }, [_vm._v("(min. £ " + _vm._s(_vm.minimumForDelivery.toFixed(2)) + ")")]), _vm._v(" "), (_vm.currentHour + '' + _vm.currentMinute >= '1900' && _vm.currentHour + '' + _vm.currentMinute <= '2200') ? _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be delivered within 45min - 1h")]) : _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Will be delivered in about 35-50 mins")])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Customer Details")]), _vm._v(" "), (!_vm.token || !_vm.user.phone || (_vm.orderType === 'delivery' && (!_vm.user.address1 || !_vm.user.postcode))) ? _c('div', {
    staticClass: "row"
  }, [(!_vm.token && _vm.orderType !== 'delivery') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-radio-group', {
    staticClass: "radio-boxes",
    attrs: {
      "id": "checkoutModeBoxes"
    },
    model: {
      value: (_vm.checkoutMode),
      callback: function($$v) {
        _vm.checkoutMode = $$v
      },
      expression: "checkoutMode"
    }
  }, [_c('b-form-radio', {
    class: [_vm.checkoutMode === 'account' ? 'is-checked' : ''],
    attrs: {
      "value": "account"
    }
  }, [_vm._v("\n                      Create an Account\n                      "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Save your details for future orders")])]), _vm._v(" "), _c('b-form-radio', {
    class: [_vm.checkoutMode === 'guest' ? 'is-checked' : ''],
    attrs: {
      "value": "guest"
    }
  }, [_vm._v("\n                      Guest Checkout\n                      "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("No account needed — quick and easy")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.token && _vm.checkoutMode === 'account') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                    After you will submit the checkout, a Kungfood account will be created for you."), _c('br'), _vm._v("\n                    If you already have an account, "), _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('u', [_vm._v("please Sign in")])]), _vm._v(".\n                  ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.isGuestMode) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "text-muted small-text guest-note"
  }, [_vm._v("\n                    Your details are taken from your payment — nothing to type in.\n                    Already have an account? "), _c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('u', [_vm._v("Sign in")])]), _vm._v(".\n                  ")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [(!_vm.token && !_vm.isGuestMode) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.firstName ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.firstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.lastName ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.lastName))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.token && !_vm.isGuestMode) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.email))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((!_vm.user || (_vm.user && !_vm.user.phone)) && !_vm.isGuestMode) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.phone ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.phone))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (!_vm.token && _vm.checkoutMode === 'account') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.password ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.password))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.passwordConfirmation ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Password Confirmation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordConfirmation),
      expression: "passwordConfirmation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Password Confirmation"
    },
    domProps: {
      "value": (_vm.passwordConfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordConfirmation = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: [_vm.postcode ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Delivery Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.postcode),
      expression: "postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Delivery Postcode"
    },
    domProps: {
      "value": (_vm.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postcode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.postcode))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    class: [_vm.address ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Delivery Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Delivery Address"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.address))]) : _vm._e()])]) : _vm._e()])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "user-static-details"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 "
  }, [_c('h4', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))]), _vm._v("\n                        " + _vm._s(_vm.user.phone)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.user.email) + "\n                      ")]), _vm._v(" "), (_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Shipping Details")]), _vm._v("\n                        " + _vm._s(_vm.user.address1)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.user.postcode)), _c('br'), _vm._v("\n                        London, United Kingdom\n                      ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Discount")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: [_vm.coupon_code ? 'show-label' : '', 'form-group coupon-input']
  }, [_c('label', [_vm._v("Coupon Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coupon_code),
      expression: "coupon_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Coupon Code"
    },
    domProps: {
      "value": (_vm.coupon_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coupon_code = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    class: [_vm.coupon_code ? 'keep-top' : '', 'btn btn-danger coupon-btn btn-fill'],
    on: {
      "click": function($event) {
        return _vm.applyCoupon()
      }
    }
  }, [_vm._v("Apply Coupon")])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "id": "payment-form",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Note")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Leave a note...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.note))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Payment")]), _vm._v(" "), (_vm.canUseWallet) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-radio-group', {
    staticClass: "radio-boxes",
    attrs: {
      "id": "paymentTypeBoxes"
    },
    model: {
      value: (_vm.paymentType),
      callback: function($$v) {
        _vm.paymentType = $$v
      },
      expression: "paymentType"
    }
  }, [_c('b-form-radio', {
    class: [_vm.paymentType === 'card' ? 'is-checked' : ''],
    attrs: {
      "value": "card"
    }
  }, [_vm._v("\n                        Card\n                        "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Pay with your bank card")])]), _vm._v(" "), _c('b-form-radio', {
    class: [_vm.paymentType === 'wallet' ? 'is-checked' : ''],
    attrs: {
      "value": "wallet"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.walletLabel) + "\n                        "), _c('span', {
    staticClass: "sublabel"
  }, [_vm._v("Fast checkout — details shared automatically")])])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.paymentType === 'wallet' && !_vm.walletReady) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "wallet-hint"
  }, [_vm._v("Please sign in to pay with " + _vm._s(_vm.walletLabel) + " for delivery orders")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.paymentErrorMessage) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                      " + _vm._s(_vm.paymentErrorMessage) + "\n                    ")])]) : _vm._e()]), _vm._v(" "), (_vm.showCardForm) ? [(_vm.hasCard === false) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentType === 'card'),
      expression: "paymentType === 'card'"
    }],
    staticClass: "row"
  }, [(!_vm.billingAsShipping) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: [_vm.billing.nameOnCard ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Name on card")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.nameOnCard),
      expression: "billing.nameOnCard"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Name on card"
    },
    domProps: {
      "value": (_vm.billing.nameOnCard)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billing, "nameOnCard", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.billingError.nameOnCard) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.billingError.nameOnCard))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.orderType === 'collection' && !_vm.token) || !_vm.billingAsShipping || (_vm.token && _vm.orderType === 'collection' && (!_vm.user.postcode || !_vm.user.address1))) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: [_vm.billing.postcode ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Billing Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.postcode),
      expression: "billing.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Billing Postcode"
    },
    domProps: {
      "value": (_vm.billing.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billing, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.billingError.postcode) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.billingError.postcode))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm.orderType === 'collection' && !_vm.token) || !_vm.billingAsShipping || (_vm.token && _vm.orderType === 'collection' && (!_vm.user.postcode || !_vm.user.address1))) ? _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    class: [_vm.billing.address ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Billing Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billing.address),
      expression: "billing.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Billing Address"
    },
    domProps: {
      "value": (_vm.billing.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billing, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.billingError.address) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.billingError.address))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [(_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "checkbox-box"
  }, [_c('b-form-checkbox', {
    class: [_vm.billingAsShipping ? 'is-checked' : ''],
    attrs: {
      "id": "billingAsShippingCheckbox",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.billingAsShipping),
      callback: function($$v) {
        _vm.billingAsShipping = $$v
      },
      expression: "billingAsShipping"
    }
  }, [_vm._v("\n                              Billing details are same as shipping\n                            ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.token || _vm.checkoutMode === 'account') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "checkbox-box"
  }, [_c('b-form-checkbox', {
    class: [_vm.saveCard ? 'is-checked' : ''],
    attrs: {
      "id": "saveCardCheckbox",
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.saveCard),
      callback: function($$v) {
        _vm.saveCard = $$v
      },
      expression: "saveCard"
    }
  }, [_vm._v("\n                              Save time and store card for future orders\n                            ")])], 1)]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentType === 'card'),
      expression: "paymentType === 'card'"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "payment-sources"
  }, _vm._l((_vm.sources), function(source) {
    return _c('div', {
      staticClass: "source"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "card-numbers"
    }, [_c('div', {
      staticClass: "text-muted"
    }, [_vm._v("Card Number")]), _vm._v(" "), _c('span', [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(source.last4))])]), _vm._v(" "), _c('div', {
      staticClass: "card-year"
    }, [_c('div', {
      staticClass: "text-muted"
    }, [_vm._v("Expire Year")]), _vm._v("\n                            " + _vm._s(source.exp_year) + "\n                          ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "add-new-card text-muted",
    on: {
      "click": function($event) {
        return _vm.addNewCard()
      }
    }
  }, [_vm._v("Add new card")])])])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.paymentType === 'card') ? _c('b-button', {
    staticClass: "btn-default btn-fill mt-3",
    attrs: {
      "disabled": !_vm.cart.length || !_vm.websiteAvailability.isOpen || !_vm.websiteAvailability.canTakeOrders || (_vm.orderType === 'delivery' && _vm.getCartTotal < _vm.minimumForDelivery),
      "type": "submit"
    }
  }, [_vm._v("Checkout")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paymentType === 'wallet' && _vm.canUseWallet && _vm.walletReady),
      expression: "paymentType === 'wallet' && canUseWallet && walletReady"
    }],
    staticClass: "mt-3",
    attrs: {
      "id": "express-checkout-element"
    }
  }), _vm._v(" "), (_vm.orderType === 'delivery' && _vm.getCartTotal < _vm.minimumForDelivery) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v("\n                      Minimum order for delivery is £" + _vm._s(_vm.minimumForDelivery.toFixed(2)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.websiteAvailability.isOpen || !_vm.websiteAvailability.canTakeOrders) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v("\n                      We are sorry but we do not take orders at this moment.\n                      " + _vm._s(_vm.websiteAvailability.canTakeOrders && !_vm.websiteAvailability.isOpen ? ("Come back please" + (_vm.websiteAvailability.nextOpeningDay ? ' on ' + _vm.websiteAvailability.nextOpeningDay : '') + " at " + (_vm.websiteAvailability.nextOpeningHour)) : '') + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.bottomError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v("\n                      " + _vm._s(_vm.bottomError) + "\n                    ")]) : _vm._e()], 1)])])])])])])]), _vm._v(" "), _c('div', {
    class: ['half-side cart', _vm.sidebarOnAbsolute ? 'on-absolute' : '', _vm.sideCartVisible ? 'visible' : '']
  }, [_c('div', {
    staticClass: "items"
  }, [_c('div', {
    staticClass: "mobile cart-back btn btn-sm btn-default",
    on: {
      "click": function($event) {
        _vm.sideCartVisible = !_vm.sideCartVisible
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Checkout")]), _vm._v(" "), _c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Your Cart")]), _vm._v(" "), _c('div', {
    staticClass: "products"
  }, _vm._l((_vm.cart), function(row, index) {
    return _c('div', {
      staticClass: "product"
    }, [_c('div', {
      staticClass: "image"
    }, [(row.image && row.image !== '') ? _c('img', {
      attrs: {
        "src": row.image,
        "alt": row.title
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(100),
        "alt": row.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title) + _vm._s(row.type === 'offer' ? ' (Lunch Box)' : ''))]), _vm._v(" "), _c('div', {
      staticClass: "quantity"
    }, [_c('div', {
      staticClass: "pull-left"
    }, [_vm._v("x " + _vm._s(row.quantity))]), _vm._v(" "), _c('div', {
      staticClass: "pull-left change-quantity"
    }, [_c('span', {
      staticClass: "plus",
      on: {
        "click": function($event) {
          return _vm.plusProductQuantity(index)
        }
      }
    }, [_vm._v("+")]), _vm._v(" "), _c('span', {
      staticClass: "minus",
      on: {
        "click": function($event) {
          return _vm.minusProductQuantity(index)
        }
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_vm._v("£" + _vm._s((row.discount > 0 ? row.discount : row.price).toFixed(2)))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), (row.type === 'offer') ? _c('div', {
      staticClass: "lunch-box-items"
    }, [_vm._l((row.items), function(item) {
      return _c('div', {
        staticClass: "lunch-box-item"
      }, [_c('div', {
        staticClass: "category-title"
      }, [_vm._v(_vm._s(item.category_title))]), _vm._v(" "), _vm._l((item.products), function(product) {
        return _c('div', {
          staticClass: "product"
        }, [_vm._v(_vm._s(product.title))])
      })], 2)
    }), _vm._v(" "), (row.note) ? _c('div', {
      staticClass: "category-title"
    }, [_vm._v("Note")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "product"
    }, [_vm._v(_vm._s(row.note))])], 2) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "delete",
      on: {
        "click": function($event) {
          return _vm.deleteProductFromCart(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "totals"
  }, [_c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v("£" + _vm._s(_vm.getCartTotal.toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.discount.amount) ? _c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Discount")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [(_vm.discountThreshold > 0 && _vm.getCartTotal < _vm.discountThreshold) ? _c('span', {
    staticClass: "text-danger small-text"
  }, [_vm._v("\n                Not applied for orders under £" + _vm._s(_vm.discountThreshold) + "\n              ")]) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.discount.amount) + _vm._s(_vm.discount.type) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.orderType === 'delivery') ? _c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v(_vm._s(_vm.deliveryCost == 0 ? 'Free' : '£' + _vm.deliveryCost.toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.adminFee > 0 && _vm.cartTotalBeforeAdminFee > 0 && _vm.cartTotalBeforeAdminFee < 10) ? _c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Admin Fee")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v("£" + _vm._s(_vm.adminFee.toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total-row"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v("£" + _vm._s(_vm.getCartFinalTotal.toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-muted small-text"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("*")]), _vm._v(" For orders under £10.00 is set an £" + _vm._s(_vm.adminFee.toFixed(2)) + " admin fee and the discount is not applied.")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    attrs: {
      "id": "card-element"
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-danger small",
    attrs: {
      "id": "card-errors",
      "role": "alert"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(338)
    }
  })])
}]}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lunchBoxes"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Lunch Boxes")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.lunchBoxes), function(box) {
    return _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "lunch-box"
    }, [(!box.available_now) ? _c('div', {
      staticClass: "badge alert-danger"
    }, [_vm._v("Not available now")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(box.title))]), _vm._v(" "), _c('p', {
      staticClass: "description text-muted"
    }, [_vm._v(_vm._s(box.description))]), _vm._v(" "), _c('div', {
      staticClass: "items"
    }, _vm._l((box.categories), function(category) {
      return _c('div', {
        staticClass: "item-group"
      }, [_c('h5', [_vm._v(_vm._s(category.title) + " "), _c('span', {
        staticClass: "text-muted"
      }, [_vm._v("(max. " + _vm._s(category.max_products) + ")")])]), _vm._v(" "), _c('div', {
        staticClass: "products"
      }, _vm._l((category.products), function(product) {
        return _c('div', {
          class: ['product', _vm.productIsSelected(box, category, product) ? 'selected' : ''],
          on: {
            "click": function($event) {
              return _vm.addToBox(box, category, product)
            }
          }
        }, [_vm._v("\n                      " + _vm._s(product.title) + "\n                    ")])
      }), 0)])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 note"
    }, [_c('h5', [_vm._v("Note")]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v("Leave a note...")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (box.note),
        expression: "box.note"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Leave a note...",
        "rows": "3"
      },
      domProps: {
        "value": (box.note)
      },
      on: {
        "keyup": function($event) {
          return _vm.noteChanged(box)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(box, "note", $event.target.value)
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "text-center change-quantity"
    }, [_c('span', {
      staticClass: "plus",
      on: {
        "click": function($event) {
          return _vm.plusQuantity(box)
        }
      }
    }, [_vm._v("+")]), _vm._v(" "), _c('span', {
      staticClass: "quantity"
    }, [_vm._v(_vm._s(box.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "minus",
      on: {
        "click": function($event) {
          return _vm.minusQuantity(box)
        }
      }
    }, [_vm._v("-")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('b-button', {
      staticClass: "btn-danger",
      attrs: {
        "disabled": !box.available_now
      },
      on: {
        "click": function($event) {
          return _vm.addToCart(box)
        }
      }
    }, [_vm._v("\n                    Add to cart\n                  ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "offer-price"
    }, [(!box.discount) ? _c('span', {
      staticClass: "no-discount"
    }, [_vm._v("£ " + _vm._s(box.price.toFixed(2)))]) : _c('span', {
      staticClass: "has-discount"
    }, [_c('span', {
      staticClass: "price"
    }, [_vm._v("£ " + _vm._s(box.price.toFixed(2)))]), _vm._v(" "), _c('span', {
      staticClass: "discount"
    }, [_vm._v("£ " + _vm._s(box.discount.toFixed(2)))])])])])])])])
  }), _vm._v(" "), (!_vm.lunchBoxes.length) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("There are no available Lunch Box Offers at the moment.")])]) : _vm._e()], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menu"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ['col-md-3 sidebar-col', _vm.categoriesVisible ? 'visible' : '']
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Menu")]), _vm._v(" "), (_vm.categories) ? _c('ul', {
    staticClass: "menu-categories"
  }, _vm._l((_vm.categories), function(category) {
    return _c('li', {
      class: _vm.selectedListCategorySlug === category.slug ? 'selected' : '',
      on: {
        "click": function($event) {
          return _vm.changeSelectedCategory(category.slug, category.title)
        }
      }
    }, [_vm._v("\n                " + _vm._s(category.title) + "\n              ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "top-bg-separator"
  })])]), _vm._v(" "), _c('div', {
    class: ['col-md-9 menu-col', _vm.categoriesVisible ? 'not-visible' : '']
  }, [_c('div', {
    staticClass: "toggle-categories btn btn-danger btn-xs",
    on: {
      "click": function($event) {
        _vm.categoriesVisible = !_vm.categoriesVisible
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  }), _vm._v(" Categories")]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "selected-menu"
    }
  }, [(_vm.selectedCategoryTitle) ? _c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.selectedCategoryTitle))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-items"
  }, [(_vm.products) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.products), function(product) {
    return _c('div', {
      class: [_vm.selectedCategorySlug === product.category.slug ? 'animated fadeIn' : 'display-none', _vm.productsFadeOut ? 'animated fadeOut' : '', 'col-md-12']
    }, [_c('div', {
      staticClass: "product-item"
    }, [_c('div', {
      staticClass: "image"
    }, [(product.gallery.length) ? _c('img', {
      attrs: {
        "src": _vm.base_url + '/' + product.gallery[0].image_path,
        "alt": product.title
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(100),
        "alt": product.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_c('h3', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(product.title))]), _vm._v(" "), _c('p', {
      staticClass: "item-description"
    }, [_vm._v("\n                        " + _vm._s(product.description) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "price"
    }, [(product.discount > 0) ? _c('span', {
      staticClass: "total-price has-discount"
    }, [_c('span', {
      staticClass: "old-price"
    }, [_vm._v("£ " + _vm._s(product.price.toFixed(2)))]), _vm._v(" "), _c('span', {
      staticClass: "discount"
    }, [_vm._v("£ " + _vm._s(product.discount.toFixed(2)))])]) : _c('span', {
      staticClass: "total-price"
    }, [_vm._v("\n                      £ " + _vm._s(product.price.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "quantity"
    }, [_c('span', {
      staticClass: "q-add",
      on: {
        "click": function($event) {
          product.quantity++
        }
      }
    }, [_vm._v("+")]), _vm._v(" "), _c('span', {
      staticClass: "q-total"
    }, [_vm._v(_vm._s(product.quantity))]), _vm._v(" "), _c('span', {
      staticClass: "q-sub",
      on: {
        "click": function($event) {
          product.quantity > 1 ? product.quantity-- : product.quantity
        }
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('div', {
      staticClass: "add-to-cart"
    }, [_c('b-button', {
      staticClass: "btn-danger add-to-cart-btn btn-sm",
      attrs: {
        "disabled": !product.availability
      },
      on: {
        "click": function($event) {
          return _vm.addToCart(product.title, product.code, product.gallery.length ? _vm.base_url + '/' + product.gallery[0].image_path : '', product.id, product.price, product.discount, product.quantity)
        }
      }
    }, [_c('span', {
      staticClass: "not-mobile"
    }, [_vm._v(_vm._s(product.availability ? 'Add to cart' : 'Out of stock'))]), _vm._v(" "), _c('span', {
      staticClass: "mobile"
    }, [_vm._v("+")])])], 1)])])
  }), _vm._v(" "), (_vm.products.length === 0 || _vm.categories.length === 0) ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n                  There are no products to display.\n                ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.products) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-center pt-2 pb-2"
  }, [_c('div', {
    staticClass: "loader-1"
  }, [_c('span')])])
}]}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myPaymentResources"
    }
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("My Payment Sources")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.sources.length) ? _c('div', {
    staticClass: "payment-sources"
  }, _vm._l((_vm.sources), function(source) {
    return _c('div', {
      staticClass: "source"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "card-numbers"
    }, [_c('div', {
      staticClass: "text-muted"
    }, [_vm._v("Card Number")]), _vm._v(" "), _c('span', [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(source.last4))])]), _vm._v(" "), _c('div', {
      staticClass: "card-year"
    }, [_c('div', {
      staticClass: "text-muted"
    }, [_vm._v("Expire Year")]), _vm._v("\n            " + _vm._s(source.exp_year) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "btn btn-danger btn-sm delete-card",
      on: {
        "click": function($event) {
          return _vm.deletePaymentSource()
        }
      }
    }, [_vm._v("×")])])
  }), 0) : _c('div', [_vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(338)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n          You have no stored cards."), _c('br'), _vm._v("\n          Place an order and select "), _c('u', [_vm._v("Store card for future orders")]), _vm._v(".\n        ")])
}]}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-us full-screen"
  }, [_c('nav', {
    staticClass: "navbar navbar-ct-default",
    attrs: {
      "role": "navigation-demo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Site title")])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navigation-example-2"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('footer', {
    staticClass: "footer-demo"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "pull-left"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("Register")])], 1)])]), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navigation-example-2"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-full-page section content"
  }, [_c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [_c('h2', {
    staticClass: "title text-danger"
  }, [_vm._v("404 Not Found")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("Oops! It seems that this page does not exist.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright pull-right"
  }, [_vm._v("\n        © 2017, made with\n        "), _c('i', {
    staticClass: "fa fa-heart heart"
  }), _vm._v(" by Paper admin\n      ")])
}]}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [(!_vm.websiteAvailability.canTakeOrders || !_vm.websiteAvailability.isOpen) ? _c('div', {
    staticClass: "is-closed-alert"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v("\n        We are sorry but we do not take orders at this moment.\n        " + _vm._s(_vm.websiteAvailability.canTakeOrders && !_vm.websiteAvailability.isOpen ? ("Come back please" + (_vm.websiteAvailability.nextOpeningDay ? ' on ' + _vm.websiteAvailability.nextOpeningDay : '') + " at " + (_vm.websiteAvailability.nextOpeningHour)) : '') + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.location && _vm.location.id === 2 && _vm.$route.name !== 'select-location') ? _c('div', {
    staticClass: "info-popup"
  }, [_c('div', {
    staticClass: "info-popup-content"
  }, [_c('closed-location-notice', [_c('div', {
    staticClass: "change-location-link",
    on: {
      "click": _vm.changeLocation
    }
  }, [_vm._v("Change location")])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('div', {
    staticClass: "responsive-top-cart"
  }, [_c('a', {
    staticClass: "btn-rotate",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showCart = !_vm.showCart
      }
    }
  }, [_c('span', {
    staticClass: "cart"
  }, [(_vm.cart.length > 0) ? _c('span', {
    staticClass: "cart-counter"
  }, [_vm._v(_vm._s(_vm.cart.length))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "ti-shopping-cart"
  })]), _vm._v(" "), _c('p', [_vm._v("\n                £" + _vm._s(_vm.getCartTotal.toFixed(2)) + "\n              ")])])]), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleMenuVisible = !_vm.toggleMenuVisible
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })]), _vm._v(" "), _c('router-link', {
    ref: "homepage",
    staticClass: "kf-logo",
    attrs: {
      "to": "/",
      "tag": "a"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(337),
      "alt": "Kungfood Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "location"
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "id": "locationName",
      "title": "Change Location"
    },
    on: {
      "click": _vm.changeLocation
    }
  }, [_vm._v(_vm._s(_vm.locationName))])])], 1), _vm._v(" "), _c('div', {
    class: [_vm.toggleMenuVisible ? 'visible' : '', 'navbar-right-menu']
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('router-link', {
    ref: "homepage",
    attrs: {
      "to": "/",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  Homepage\n                ")])])]), _vm._v(" "), _c('router-link', {
    ref: "menu",
    attrs: {
      "to": "/menu",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  Menu\n                ")])])]), _vm._v(" "), _c('router-link', {
    ref: "lunchBoxes",
    attrs: {
      "to": "/lunch-boxes",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  Lunch Boxes\n                ")])])]), _vm._v(" "), _c('router-link', {
    ref: "contact",
    attrs: {
      "to": "/contact",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  Contact\n                ")])])]), _vm._v(" "), _c('router-link', {
    ref: "profile",
    attrs: {
      "to": "/profile",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleMenuVisible = false
      }
    }
  }, [_c('a', {
    staticClass: "btn-rotate"
  }, [_c('p', [_vm._v("\n                  " + _vm._s(_vm.user ? 'Profile' : 'Sign in') + "\n                ")])])]), _vm._v(" "), _c('li', {
    staticClass: "cart"
  }, [_c('a', {
    staticClass: "btn-rotate",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.showCart = !_vm.showCart
      }
    }
  }, [_c('span', {
    staticClass: "cart"
  }, [(_vm.cart.length > 0) ? _c('span', {
    staticClass: "cart-counter"
  }, [_vm._v(_vm._s(_vm.cart.length))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "ti-shopping-cart"
  })]), _vm._v(" "), _c('p', [_vm._v("\n                  £" + _vm._s(_vm.getCartTotal.toFixed(2)) + "\n                ")])])])], 1)])]), _vm._v(" "), _c('CartPopup', {
    attrs: {
      "show-cart": _vm.showCart
    },
    on: {
      "closeShowCart": _vm.closeShowCart
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "closed-location-message"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "version": "1.1",
      "id": "Capa_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 512 512",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#B4826E"
    },
    attrs: {
      "d": "M316.492,308.418H195.507V172.52h120.986V308.418z M155.553,366.66v135.898h200.893V366.66H155.553z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#A06E5F"
    },
    attrs: {
      "d": "M297.359,312.786v189.772h-82.72V312.786h19.133V172.52h44.455v140.267L297.359,312.786L297.359,312.786z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#E6C8A0"
    },
    attrs: {
      "d": "M135.464,392.869v-31.063c0-2.681,2.141-4.854,4.783-4.854h231.505c2.642,0,4.783,2.173,4.783,4.854v31.063c0,2.681-2.141,4.854-4.783,4.854H140.246C137.605,397.723,135.464,395.55,135.464,392.869z M400.451,444.316H111.547c-2.642,0-4.783,2.173-4.783,4.854v21.355c0,2.681,2.141,4.854,4.783,4.854h288.903c2.642,0,4.783-2.173,4.783-4.854V449.17C405.234,446.489,403.092,444.316,400.451,444.316z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#C83741"
    },
    attrs: {
      "d": "M416.187,327.832L416.187,327.832c0,16.083-12.849,29.121-28.699,29.121H263.125h-14.252H124.511c-15.85,0-28.699-13.038-28.699-29.121l0,0l42.008-17.074c19.307-7.847,35.818-21.447,47.355-39.007l0,0c0.887-1.35,2.381-2.161,3.98-2.161h59.719h14.252h59.719c1.599,0,3.093,0.811,3.98,2.161l0,0c11.537,17.56,28.048,31.16,47.355,39.007L416.187,327.832z M376.536,170.659l-32.1-15.793c-28.283-13.915-52.879-34.487-71.738-60.003l0,0h-33.395l0,0c-18.859,25.515-43.455,46.088-71.738,60.003l-32.1,15.793v26.128h241.071V170.659z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#D2B48C"
    },
    attrs: {
      "d": "M443.5,478.291v21.355c0,2.681-2.141,4.854-4.783,4.854H73.282c-2.642,0-4.783-2.173-4.783-4.854v-21.355c0-2.681,2.141-4.854,4.783-4.854h306.739c0.605-0.813,0.978-1.814,0.978-2.912V449.17c0-2.681-2.141-4.854-4.783-4.854h24.235c2.642,0,4.783,2.173,4.783,4.854v21.355c0,1.098-0.373,2.099-0.978,2.912h34.46C441.359,473.438,443.5,475.61,443.5,478.291z M347.518,397.723h24.235c2.642,0,4.783-2.173,4.783-4.854v-31.063c0-2.681-2.141-4.854-4.783-4.854h-24.235c2.642,0,4.783,2.173,4.783,4.854v31.063C352.3,395.55,350.159,397.723,347.518,397.723z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#C5AB8C"
    },
    attrs: {
      "d": "M443.5,478.291v21.355c0,2.681-2.141,4.854-4.783,4.854h-24.235c2.642,0,4.783-2.173,4.783-4.854v-21.355c0-2.681-2.142-4.854-4.783-4.854h24.235C441.359,473.438,443.5,475.61,443.5,478.291z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#AA4141"
    },
    attrs: {
      "d": "M376.536,196.787h-90.119c-14.885-20.306-23.72-45.608-23.72-73.045c0-9.953,1.171-19.623,3.362-28.878h6.639c18.859,25.515,43.455,46.088,71.738,60.003l32.1,15.793V196.787z M374.18,310.758c-19.307-7.847-35.818-21.447-47.355-39.007c-0.887-1.35-2.381-2.161-3.98-2.161h-19.969c-0.311,3.598-0.479,7.239-0.479,10.92c0,28.99,9.863,55.596,26.304,76.443h58.788c15.85,0,28.699-13.038,28.699-29.121L374.18,310.758z"
    }
  }), _c('g', [_c('path', {
    staticStyle: {
      "fill": "#963737"
    },
    attrs: {
      "d": "M440.221,325.315l-6.617,12.309c-10.058,18.711-29.385,30.353-50.389,30.353h-9.932H138.715h-9.932c-21.004,0-40.331-11.642-50.389-30.353l-6.617-12.309c-2.073-3.856,1.566-8.3,5.682-6.939l0,0c21.569,7.137,44.114,10.773,66.801,10.773h223.478c22.687,0,45.232-3.636,66.801-10.773l0,0C438.656,317.014,442.294,321.458,440.221,325.315z M107.986,180.995c10.058,18.711,29.385,30.353,50.39,30.353h9.932h175.383h9.932c21.004,0,40.331-11.642,50.39-30.353l6.617-12.309c2.073-3.856-1.566-8.301-5.682-6.939l0,0c-21.569,7.137-44.114,10.773-66.801,10.773H173.854c-22.687,0-45.232-3.636-66.801-10.773l0,0c-4.116-1.362-7.755,3.082-5.682,6.939L107.986,180.995z"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#963737"
    },
    attrs: {
      "d": "M272.55,70.986c4.909,2.313,8.321,7.346,8.321,13.2l0,0c0,8.041-6.424,14.561-14.349,14.561h-21.046c-7.925,0-14.349-6.519-14.349-14.561l0,0c0-5.854,3.412-10.887,8.321-13.2c-5.105-4.622-8.321-11.345-8.321-18.833l0,0c0-13.939,11.136-25.238,24.872-25.238c13.737,0,24.872,11.3,24.872,25.238l0,0C280.872,59.64,277.656,66.364,272.55,70.986z"
    }
  })]), _c('path', {
    attrs: {
      "d": "M438.691,465.938h-25.958V449.17c0-6.812-5.51-12.354-12.283-12.354h-36.505v-31.594h7.807c6.773,0,12.283-5.542,12.283-12.354v-17.407c23.463-0.299,44.933-13.373,56.176-34.287l6.617-12.311c2.419-4.501,1.86-9.938-1.424-13.848c-3.249-3.869-8.441-5.345-13.222-3.761c-7.306,2.417-14.718,4.408-22.205,5.986c-0.16-0.078-0.319-0.159-0.486-0.227l-32.488-13.205c-17.978-7.307-33.162-19.816-43.911-36.176c-2.066-3.147-5.411-5.126-9.1-5.472v-43.314h29.63c23.783,0,45.623-13.144,56.995-34.302l6.618-12.31c2.419-4.502,1.86-9.938-1.424-13.848c-3.249-3.868-8.44-5.343-13.221-3.761c-8.991,2.975-18.139,5.314-27.394,7.016l-27.452-13.506c-24.452-12.03-46.368-29.551-63.666-50.837c2.695-3.668,4.292-8.206,4.292-13.113c0-5.267-1.863-10.271-5.139-14.2c3.246-5.043,5.139-11.037,5.139-17.468v-0.731c0-15.268-10.628-28.093-24.872-31.486V7.5c0-4.142-3.357-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5v12.801c-14.244,3.393-24.873,16.218-24.873,31.486v0.731c0,6.431,1.893,12.425,5.14,17.469c-3.274,3.937-5.14,8.961-5.14,14.198c0,4.906,1.596,9.441,4.289,13.109c-17.294,21.283-39.217,38.815-63.663,50.842l-26.683,13.127c-0.242,0.119-0.474,0.251-0.698,0.392c-9.279-1.703-18.451-4.046-27.464-7.029c-4.784-1.582-9.973-0.107-13.222,3.762c-3.284,3.911-3.843,9.346-1.422,13.848l6.617,12.309c11.374,21.158,33.213,34.302,56.996,34.302h29.63v43.314c-3.688,0.346-7.032,2.325-9.1,5.471c-10.75,16.361-25.934,28.871-43.911,36.177l-33.022,13.421c-7.471-1.576-14.867-3.563-22.158-5.976c-4.784-1.582-9.973-0.106-13.222,3.762c-3.284,3.911-3.843,9.347-1.422,13.848l6.617,12.31c11.242,20.914,32.712,33.989,56.176,34.287v17.407c0,6.812,5.51,12.354,12.283,12.354h7.806v31.594h-36.505c-6.773,0-12.283,5.542-12.283,12.354v16.768H73.307c-6.787,0-12.308,5.542-12.308,12.354v21.355c0,6.811,5.521,12.353,12.308,12.353h365.385c6.786,0,12.308-5.542,12.308-12.354v-21.355C451,471.479,445.479,465.938,438.691,465.938z M348.945,436.816h-44.086v-31.594h44.086V436.816L348.945,436.816z M289.859,405.223v31.594h-67.72v-31.594H289.859z M308.992,262.09h-23.266v-43.242h23.266V262.09z M270.727,218.848v43.242h-29.455v-43.242L270.727,218.848L270.727,218.848z M238.626,84.186c0-1.337,0.379-2.622,1.049-3.729c4.796,2.813,10.373,4.435,16.324,4.435s11.528-1.621,16.324-4.435c0.669,1.104,1.048,2.386,1.048,3.73c0,3.893-3.072,7.061-6.849,7.061h-21.046C241.699,91.246,238.626,88.079,238.626,84.186z M238.626,51.787c0-9.579,7.793-17.373,17.373-17.373c9.58,0,17.372,7.793,17.372,17.373v0.731c0,9.579-7.793,17.373-17.372,17.373c-9.579,0-17.373-7.793-17.373-17.373V51.787z M170.874,161.595c26.798-13.184,50.777-32.497,69.564-55.948c1.618,0.387,3.304,0.598,5.037,0.598h21.046c1.733,0,3.417-0.211,5.035-0.598c18.792,23.455,42.761,42.76,69.566,55.947l6.499,3.197c-3.153,0.146-6.312,0.227-9.477,0.227H173.854c-3.165,0-6.324-0.082-9.477-0.227L170.874,161.595z M114.592,177.443l-3.535-6.577c20.401,6.076,41.494,9.153,62.796,9.153h164.292c21.303,0,42.394-3.077,62.796-9.153l-3.536,6.577c-8.754,16.287-25.531,26.404-43.783,26.404H158.376C140.124,203.848,123.347,193.73,114.592,177.443z M226.271,218.848v43.242h-23.266v-43.242L226.271,218.848L226.271,218.848z M140.643,317.707c20.357-8.274,37.612-22.301,49.986-40.617h130.739c12.374,18.316,29.629,32.343,49.986,40.617l8.777,3.567c-4.12,0.249-8.252,0.375-12.393,0.375H144.26c-4.141,0-8.274-0.126-12.394-0.375L140.643,317.707z M84.999,334.073l-3.535-6.578c20.4,6.076,41.493,9.153,62.796,9.153h223.478c21.303,0,42.396-3.077,62.796-9.153L427,334.073c-8.756,16.287-25.532,26.404-43.784,26.404H128.783C110.531,360.477,93.754,350.359,84.999,334.073z M142.964,375.477h226.072v14.746H142.964V375.477z M163.053,405.223h44.086v31.594h-44.086V405.223z M436,497h-360v-16.063h232.403c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H114.264v-14.121h283.469v14.121h-58.562c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5H436V497z"
    }
  }), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g'), _c('g')]), _vm._v(" "), _c('p', {
    staticClass: "location-name"
  }, [_vm._v("Clerkenwell")]), _vm._v(" "), _c('h2', [_vm._v("Closed for renovation")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "message"
  }, [_vm._v("We're sorry, but the store is closed for renovation."), _c('br'), _vm._v("See you soon!")])
}]}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('svg', {
    attrs: {
      "viewBox": "-2000 -1000 4000 2000"
    }
  }, [_c('path', {
    attrs: {
      "id": "inf",
      "d": "M354-354A500 500 0 1 1 354 354L-354-354A500 500 0 1 0-354 354z"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "xlink:href": "#inf",
      "stroke-dasharray": "1570 5143",
      "stroke-dashoffset": "6713px"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('notification', {
      key: notification,
      attrs: {
        "message": notification.message,
        "icon": notification.icon,
        "type": notification.type,
        "vertical-align": notification.verticalAlign,
        "horizontal-align": notification.horizontalAlign
      },
      on: {
        "on-close": function($event) {
          return _vm.removeNotification(index)
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.name ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Full Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.email))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    class: [_vm.subject ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Subject")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Subject"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.subject))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Leave a note...",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.formError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.message))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-btn', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendMessage()
      }
    }
  }, [_vm._v("Send Message")])], 1)])])])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Contact Us")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                We take all your queries very seriously. Please let us know your amazing feedback or if you\n                experienced something that you would like to be improved.\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-map"
  }, [_c('div', {
    staticClass: "map"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])])
}]}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "footer-socials"
  }, [_c('a', {
    staticClass: "social",
    attrs: {
      "href": _vm.socials.facebook ? _vm.socials.facebook : '#',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social",
    attrs: {
      "href": _vm.socials.twitter ? _vm.socials.twitter : '#',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social",
    attrs: {
      "href": _vm.socials.instagram ? _vm.socials.instagram : '#',
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contacts"
  }, [_c('div', {
    staticClass: "telephone"
  }, [_c('span', [_vm._v("Telephone:")]), _vm._v(" " + _vm._s(_vm.websiteContacts.phone))]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('span', [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.websiteContacts.email))]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.websiteContacts.address))])]), _vm._v(" "), _c('router-link', {
    staticClass: "find-us btn btn-danger btn-fill btn-secondary",
    attrs: {
      "to": "/contact",
      "tag": "button"
    }
  }, [_vm._v("\n          Find us on map\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n      " + _vm._s(_vm.year) + " Copyright © Kungfood\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "kf-footer-logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(337),
      "alt": "Kungfood Logo"
    }
  })])
}]}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.label) ? _c('label', [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('input', _vm._b({
    staticClass: "form-control border-input",
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }, 'input', _vm.$props, false))])
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Edit my details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.customer.first_name ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.first_name),
      expression: "customer.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.customer.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.first_name !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.first_name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.customer.last_name ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.last_name),
      expression: "customer.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.customer.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.last_name !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.last_name))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: [_vm.customer.phone ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.phone),
      expression: "customer.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.customer.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.phone !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.phone))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    class: [_vm.customer.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.email),
      expression: "customer.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.customer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.email !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.email))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    class: [_vm.customer.address ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.address),
      expression: "customer.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.customer.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.address !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.address))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: [_vm.customer.postcode ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.postcode),
      expression: "customer.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.customer.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.postcode !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.postcode))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-btn', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editProfile($event)
      }
    }
  }, [_vm._v("Update Details")])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('notifications'), _vm._v(" "), _c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "mainPanel"
    }
  }, [_c('TopNavbar'), _vm._v(" "), _c('Content'), _vm._v(" "), _c('ContentFooter')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "restore-password"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "login"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Restore Password")]), _vm._v(" "), (_vm.topMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v(_vm._s(_vm.topMessage))])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    class: [_vm.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailError) ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.emailError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.restore($event)
      }
    }
  }, [_vm._v("Restore")])], 1)])])])])])])
},staticRenderFns: []}

/***/ })
]),[376]);


// WEBPACK FOOTER //
// static/js/app.46d189c24ada806ba4c1.js